<template>
    <Loader v-if="loading"/>
    <div v-if="loaded_data">
        <Card>
            <template #header>
                <div class="p-3 pb-0">
                    <h2>Atleta: {{ atleta.cognome }} {{ atleta.nome }}
                    <Button
                        label="Invia Notifica"
                        icon="pi pi-bell"
                        class="p-button-outlined p-button-info"
                        @click="openSendNotificationDialog" style='float:right'
                    />
                    <Button
                        label="Invia Presentazione App"
                        icon="pi pi-envelope"
                        class="p-button-outlined p-button-info mr-2"
                        @click="confirmSendAppPresentation" style='float:right'
                    /></h2>
                </div>
            </template>
            <template #content>
                <div class="col-12 flex">
                    <div class="col-12 flex flex-column md:col-6" >
                        <Card style="background-color: #d32f2f;
                        text-align: center;
                        color: white;">
                            <template #title>Da pagare</template>
                            <template #content>
                                <h2>
                                    {{ totalToPay }} &euro;
                                </h2>
                            </template>
                        </Card>
                    </div>
                    <div class="col-12 flex flex-column md:col-6">
                        <Card style="background-color: #689f38; text-align: center; color: white;">
                            <template #title>Pagato</template>
                            <template #content>
                                <h2>{{ totalPaid }} &euro;</h2>
                            </template>
                        </Card>
                    </div>
                </div>

                <Accordion :activeIndex="5">
                  <AccordionTab header="Anagrafica e Profilo Fiscale">
    <div class="grid p-fluid">
        <div class="col-12 lg:col-6">
            <div class="surface-100 p-3 border-round shadow-1 h-full">
                <div class="flex justify-content-between align-items-center mb-3">
                    <h4 class="text-lg font-semibold text-primary">Dati Anagrafici Atleta</h4>
                    <div class="flex align-items-center">
                        <label class="mr-2 text-sm">{{ !update ? 'Modifica' : 'Salva' }}</label>
                        <InputSwitch v-model="update" @change="changeUpdate" />
                    </div>
                </div>

                <div class="grid flex-wrap">
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="cognome">Cognome</label>
                        <InputText id="cognome" v-model="atleta.cognome" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.cognome}]" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="nome">Nome</label>
                        <InputText id="nome" v-model="atleta.nome" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.nome}]" />
                    </div>

                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Data di nascita</label>
                        <Calendar :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.datadinascita}]" v-model="atleta.datadinascita" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" :disabled="!update" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Luogo di nascita</label>
                        <InputText :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.luogodinascita}]" v-model="atleta.luogodinascita" :disabled="!update" />
                    </div>

                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Indirizzo</label>
                        <InputText :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.indirizzo}]" v-model="atleta.indirizzo" :disabled="!update" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Città</label>
                        <Dropdown v-model="atleta.comune" :options="citta" filter optionLabel="name" :disabled="!update" class="text_toupper inputfield w-full" />
                    </div>

                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Cap</label>
                        <InputText :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.cap}]" v-model="atleta.cap" :disabled="!update" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column justify-content-center align-items-center">
                        <label class="mb-3">Sesso</label>
                        <div class="flex justify-content-center gap-3">
                            <div v-for="gender in genders" :key="gender.key" class="flex align-items-center">
                                <RadioButton v-model="atleta.sesso" :id="gender.key" name="dynamic" :value="gender.name" :disabled="!update" />
                                <label :for="gender.key" class="ml-2">{{ gender.name }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 flex flex-column gap-2">
                        <label for="cf">Codice fiscale</label>
                        <InputText id="cf" v-model="atleta.codfis" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.codfis}]" :disabled="!update" />
                    </div>

                   <div class="col-12 flex flex-column gap-2">
    <label class="mb-3">Genitore/Profilo fiscale</label>
    
    <div class="flex gap-2">
        <div class="flex-grow-1">
            <Dropdown 
                v-model="atleta.utente" 
                :options="users" 
                filter 
                optionLabel="name" 
                :key="atleta.utente?.id || 'new'" 
                :disabled="!update" 
                @change="onUtenteChange"
                class="text_toupper inputfield w-full" 
            />
        </div>
        <Button 
            @click="showUtente(atleta.utente ? atleta.utente.id : -1)" 
            label="Dettagli" 
            icon="pi pi-external-link" 
            class="p-button-secondary p-button-sm flex-shrink-0" 
            :disabled="!atleta.utente || !atleta.utente.id || atleta.utente.id === -1"
            style="height: 42px;max-width:300px;margin-left:10px" 
        />
        <Button 
            v-if="siblingAthletes.length > 0"
            @click="showSiblingAthletesDialog" 
            label="Mostra atleti associati" 
            icon="pi pi-users" 
            class="p-button-info p-button-sm flex-shrink-0" 
            style="height: 42px;max-width:300px;margin-left:10px" 
        />
    </div>
</div>
                </div>
            </div>
        </div>

        <div class="col-12 lg:col-6">
            <div class="surface-100 p-3 border-round shadow-1 h-full">
                <div class="flex justify-content-between align-items-center mb-3">
                    <h4 class="text-lg font-semibold text-primary">Dati Profilo Fiscale (Utente)</h4>
                    <div class="flex align-items-center">
                        <label class="mr-2 text-sm">{{ !updateUtente ? 'Modifica' : 'Salva' }}</label>
                        <InputSwitch v-model="updateUtente" @change="changeUpdateUtente" />
                    </div>
                </div>

                <div class="grid flex-wrap">
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="utenteCognome">Cognome</label>
                        <InputText id="utenteCognome" v-model="utente.cognome" :disabled="!updateUtente" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.cognome}]" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="utenteNome">Nome</label>
                        <InputText id="utenteNome" v-model="utente.nome" :disabled="!updateUtente" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.nome}]" />
                    </div>

                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Data di nascita</label>
                        <Calendar :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.datadinascita}]" v-model="utente.datadinascita" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" :disabled="!updateUtente" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label>Luogo di nascita</label>
                        <InputText :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.luogodinascita}]" v-model="utente.luogodinascita" :disabled="!updateUtente" />
                    </div>

                    <div class="col-12 flex flex-column gap-2">
                        <label>Indirizzo</label>
                        <InputText :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.indirizzo}]" v-model="utente.indirizzo" :disabled="!updateUtente" />
                    </div>
                    
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="telefono">Telefono</label>
                        <InputText id="telefono" v-model="utente.telefono" :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.telefono}]" :disabled="!updateUtente" />
                    </div>
                    <div class="col-12 md:col-6 flex flex-column gap-2">
                        <label for="codfis">Codice fiscale</label>
                        <InputText id="codfis" v-model="utente.codfis" :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.codfis}]" :disabled="!updateUtente" />
                    </div>

                    <div class="col-12 flex flex-column gap-2">
                        <label for="username">Email</label>
                        <InputText id="username" v-model="utente.username" :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.username}]" :disabled="!updateUtente" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</AccordionTab>

<AccordionTab header="FIGC" v-if="figc.length > 0">
  <DataTable 
    :value="figc" 
    dataKey="id"
    class="p-datatable-sm"
    stripedRows
    responsiveLayout="scroll"
  >
    <Column field="AnnoScadenzaContratto" header="Stagione" sortable>
      <template #body="{data}">{{ data.AnnoScadenzaContratto ? `${data.AnnoScadenzaContratto - 1}/${data.AnnoScadenzaContratto}` : '-' }}</template>
    </Column>
    <Column field="Matricola" header="Matricola" sortable />
    <Column field="Nome" header="Nome completo" sortable />
    <Column field="Disciplina" header="Disciplina" />
    <Column field="DataNascita" header="Data di Nascita" />
    <Column field="DataTesseramento" header="Data Tesseramento" />
    <Column field="AnnoScadenzaContratto" header="Scadenza Contratto" />
    <Column field="Status" header="Status" />
  </DataTable>
</AccordionTab>

                <AccordionTab header="Documenti">
    <div @click="showIscrizione(atleta.id)" class='p-button p-button-warning justify-content-end align-items-center' style="margin-bottom:5px;float:right">Scarica Modulo di iscrizione</div>
    <Button label="Aggiungi" raised class="p-button " @click="openDialogFiles" style="margin-bottom:5px"/>
    <p v-if="docs.length==0">Non ci sono documenti al momento</p>

    <DataTable :value="docs" class="p-datatable-gridlines" v-else>
        <Column field="creation_time" header="Data caricamento">
            <template #body="{data}">
                {{ moment(data.creation_time).format('DD/MM/YYYY') }}
            </template>
        </Column>
        
        <Column field="datascadenza" header="Data Scadenza">
            <template #body="{data}">
                <div :class="{ 
                    'font-bold text-red-600': moment(data.datascadenza).isBefore(moment(), 'day'),
                    'text-orange-500': moment(data.datascadenza).isBefore(moment().add(30, 'days'), 'day') && moment(data.datascadenza).isAfter(moment(), 'day') 
                }">
                    {{ moment(data.datascadenza).format('DD/MM/YYYY') }}
                    
                    <Tag 
                        v-if="moment(data.datascadenza).isBefore(moment(), 'day')" 
                        value="SCADUTO" 
                        severity="danger" 
                        class="ml-2"
                    />
                    <Tag 
                        v-else-if="moment(data.datascadenza).isBefore(moment().add(30, 'days'), 'day')" 
                        value="In Scadenza" 
                        severity="warning" 
                        class="ml-2"
                    />
                </div>
            </template>
        </Column>
        
        <Column field="tipo" header="Tipologia"></Column>
        <Column field="nome" header="File">
            <template #body="{data}">
                <Button severity="help" @click="getDocUrl(data.path)" >{{ data.nome }}</Button>
            </template>
            </Column>
        <Column field="validato" header="Validato">
            <template #body="{data}">
                {{ data.data_approvazione?moment(data.data_approvazione).format('DD/MM/YYYY HH:mm:ss'):'' }}
            </template>
        </Column>
        <Column field="id" header="" style="width:150px">
            <template #body="{data}">
                <div class="flex gap-2">
                    <Button icon="pi pi-pencil" class="p-button-warning" @click="openEditDocDialog(data)" v-tooltip="'Modifica'"></Button>
                    <Button severity="danger" class='p-button-danger'  icon="pi pi-trash"  @click="removeDoc(data.id_documento)" v-tooltip="'Elimina'"></Button>
                </div>
            </template>
        </Column>
    </DataTable>
</AccordionTab>
                   <AccordionTab header="Corsi">
  <div class="flex justify-between items-center mb-3">
    <Button label="Aggiungi un corso" icon="pi pi-plus" class="p-button-warning p-button-raised" @click="addCorso" />
  </div>
  <p v-if="corsi.length === 0" class="text-center text-gray-500">
    Non ci sono corsi al momento


  </p>
  <DataTable
    v-else
    :value="corsi"
    v-model:expandedRows="expandedRows"  dataKey="id_corso"                 class="p-datatable-striped p-datatable-gridlines"
    responsiveLayout="scroll"
  >
    <Column :expander="true" headerStyle="width: 3rem" />

    <Column field="nome_corso" header="Nome Corso" style="min-width: 12rem">
      <template #body="{ data }">
        <Button @click="goToCorso(data.id_corso)" class="p-button-link">
          {{ data.nome_corso }}
        </Button>
      </template>
    </Column>
    <Column field="tipologia" header="Tipologia" style="min-width: 8rem"></Column>
    <Column field="data_inizio_corso" header="Inizio" style="width: 7rem">
      <template #body="{ data }">
        {{ moment(data.data_inizio_corso).format('DD/MM/YYYY') }}
      </template>
    </Column>
    <Column field="data_fine_corso" header="Fine" style="width: 7rem">
      <template #body="{ data }">
        {{ moment(data.data_fine_corso).format('DD/MM/YYYY') }}
      </template>
    </Column>
    <Column field="n_workouts" header="Allenamenti" style="width: 6rem"></Column>
    <Column field="presenze" header="Presenze" style="width: 6rem"></Column>
    <Column field="assenze" header="Assenze" style="width: 6rem"></Column>
    <Column field="pagato" header="Pagato" style="width: 6rem"></Column>
    <Column field="da_pagare" header="Da Pagare" style="width: 6rem"></Column>
    <Column header="Azioni" style="min-width: 22rem">
      <template #body="{ data }">
        <div class="flex flex-row flex-nowrap gap-2">
          <Button label="" icon="pi pi-trash" class="p-button-danger p-button-sm" @click="removeCorso(data.id_iscrizione)" />
          <Button v-if="data.pagato == 0 && data.n_rate != -1" label="Reimposta pagamenti" icon="pi pi-refresh" class="p-button-warning p-button-sm" @click="resetPagamenti(data)" />
          <Button v-if="data.n_rate == -1" label="Completa" icon="pi pi-check" class="p-button-success p-button-sm" @click="setRate(data)" />
          <Button v-if="data.cod_type_corso == 7" label="Può prenotare?" icon="pi pi-calendar" class="p-button-info p-button-sm" @click="openMotiviDialog(data.id_corso)" />
        </div>
      </template>
    </Column>

    <template #expansion="{ data }">
      <div v-if="coursesMonthlyData[data.id_corso]" class="p-3">
        <h3>Dettaglio Presenze Mensili per {{ data.nome_corso }}</h3>
        <DataTable :value="coursesMonthlyData[data.id_corso]" responsiveLayout="scroll" class="p-datatable-gridlines mt-2">
          <Column field="mese" header="Mese"></Column>
          <Column field="quanti" header="Presenze nel mese"></Column>
          <Column field="pagatoNelMese" header="Importo pagato nel mese" style="text-align: right">
            <template #body="{ data: monthlyData }"> <span :style="{ color: monthlyData.pagatoNelMese === 0 ? 'red' : 'inherit' }">
                {{ monthlyData.pagatoNelMese }}
              </span>
            </template>
          </Column>
          <Column header="Dettaglio" style="width: 5rem">
            <template #body="{ data: monthlyData }">
              <Button icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" @click="showDailyDetails(data.id_corso, monthlyData.mese)" v-tooltip="'Vedi dettaglio giornaliero'" />
            </template>
          </Column>
        </DataTable>
      </div>
      <div v-else class="p-3 text-center text-gray-500">
          Nessun dato di presenze mensili disponibile per questo corso.
      </div>
    </template>
  </DataTable>

  <div v-if="coursesMonthlyDataOLD" class="p-3">

  <div 
    v-for="(rows, key) in coursesMonthlyDataOLD" 
    :key="key" 
    class="mb-5"
  >
    <h3>Dettaglio Presenze – {{ key }}</h3>

    <DataTable 
      :value="rows" 
      responsiveLayout="scroll" 
      class="p-datatable-gridlines mt-2"
    >
      <Column field="mese" header="Mese" />

      <Column field="quanti" header="Presenze nel mese" />

      <Column 
        field="pagatoNelMese" 
        header="Importo pagato nel mese" 
        style="text-align: right"
      >
        <template #body="{ data: monthlyData }">
          <span :style="{ color: monthlyData.pagatoNelMese === 0 ? 'red' : 'inherit' }">
            {{ monthlyData.pagatoNelMese }}
          </span>
        </template>
      </Column>

    </DataTable>
  </div>

</div>

  
  <div v-if="aggregatePresenceData.length > 0" class="mt-5 p-3 surface-100 border-round shadow-1">
    <h3>Riepilogo Presenze Mensili (Tutti i corsi)</h3>
    <DataTable :value="aggregatePresenceData" class="p-datatable-gridlines mt-2" responsiveLayout="scroll">
      <Column field="mese" header="Mese"></Column>
      <Column field="quanti" header="Totale Presenze"></Column>
      <Column field="pagatoNelMese" header="Totale Pagato nel Mese" style="text-align: right">
        <template #body="{ data }">
          <span :style="{ color: data.pagatoNelMese === 0 ? 'red' : 'inherit' }">
            {{ data.pagatoNelMese }} €
          </span>
        </template>
      </Column>
      <Column header="Dettaglio" style="width: 5rem">
        <template #body="{ data }">
          <Button icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" @click="showDailyDetails('all', data.mese)" v-tooltip="'Vedi dettaglio di tutti i corsi'" />
        </template>
      </Column>
    </DataTable>
  </div>
  
  </AccordionTab>

                                    <AccordionTab header="FisioSteoLab" v-if="prenotazioni.length > 0">


  <p v-if="prenotazioni.length === 0" class="text-center text-gray-500">
    Non ci sono prenotazioni al momento
  </p>

  <DataTable 
    v-else 
    :value="prenotazioni" 
    class="p-datatable-striped p-datatable-gridlines" 
    responsiveLayout="scroll"
  >
    <Column field="tipologia" header="Tipologia" style="min-width: 12rem">
      
    </Column>


    <Column field="data_inizio" header="Data" style="width: 7rem">
      <template #body="{ data }">
        {{ moment(data.data_start).format('DD/MM/YYYY HH:mm') }}
      </template>
    </Column>

    <Column field="data_end" header="Fine" style="width: 7rem">
      <template #body="{ data }">
        {{ moment(data.data_end).format('DD/MM/YYYY HH:mm') }}
      </template>
    </Column>
    <Column field="creation_time" header="Prenotazione" style="width: 7rem">
      <template #body="{ data }">
        {{ moment(data.creation_time).format('DD/MM/YYYY HH:mm') }}
      </template>
    </Column>

    <Column field="nota" header="Nota" style="width: 6rem"></Column>

  </DataTable>
</AccordionTab>   
              


                   <AccordionTab header="Da pagare">
        <Button label="Aggiungi prodotto" raised class="p-button" @click="openDialogProdotti" style="margin-bottom:5px;margin-right:5px"/>
        <Button label="Aggiungi kit" raised class="p-button" @click="openDialogKit" style="margin-bottom:5px;margin-right:5px"/>
        <Button label="Aggiungi abbigliamento da store" raised class="p-button p-button-warning" @click="gotoVendita" style="margin-bottom:5px"/>
        <Button label="Aggiungi rata corso" v-if="corsi.length>0" raised class="p-button" @click="openPopup()" style="float:right"/>

        <p v-if="dapagare.length==0" style="padding:20px">Non c'è niente da pagare al momento</p>
        <DataTable :value="dapagare" v-else class="p-datatable-gridlines" v-model:selection="pagamento.richieste_pagamenti" :metaKeySelection="false">
       
            <Column header="" style="width: 3rem;">
                <template #body="{ data }">
                    <input 
                        type="checkbox" 
                        :checked="data.selected" 
                        @change="onCheckboxChange(data)"
                    />
                </template>
            </Column>

            <Column field="corso" header="Descrizione">
                <template #body="{data}">
                    {{ data.n_rata ? 'Rata n. ' + data.n_rata + ' del corso ' + data.corso : '' }}
                    {{ data.kit ? 'Kit ' + data.kit : '' }}
                    <template v-if="data.prodotto">
                        {{ data.prodotto }}
                        <span v-if="data.id_iscrizione && data.corso"> (corso {{ data.corso }})</span>
                        <span v-if="data.id_torneo_ext && data.note"> (torneo {{ data.note }})</span>
                    </template>
                </template>
            </Column>
            
            <Column field="data_scadenza" header="Data scadenza">
                <template #body="{data}">
                    <Button 
                        class="p-button-link p-button-text" 
                        :class="getScadenzaClass(data.data_scadenza)"
                        @click="openDialogScadenza(data.id, data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'), 'data_scadenza')"
                    >
                        {{ data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/Y') : '...' }}    
                    </Button>
                </template>
            </Column>
            
            <Column field="note" header="Note"></Column>
            
            <Column field="importo" header="Importo €" style='text-align: right;font-weight: bold; width: 12rem'>
                <template #body="{ data }">
                    <div class="flex align-items-center justify-content-end">
                        <Button 
                            :label="'€ ' + data.importo" 
                            class="p-button-text" 
                            @click="openDialogModificaImporto(data)"
                        />
                        <Button 
                            v-if="(data.id_iscrizione || data.id_torneo_ext || data.id_prodotto || data.id_kit) && data.importo > 0"
                            icon="pi pi-directions" 
                            class="p-button-rounded p-button-info p-button-text ml-2" 
                            v-tooltip.top="'Dividi in 2 rate'"
                            @click="openSplitDialog(data)"
                        />
                    </div>
                </template>
            </Column>
            
            <Column header="Azioni" style="text-align: center; width: 100px;">
                <template #body="{ data }">
                    <i class="pi pi-trash" style="cursor: pointer;" @click="removeToPay(data.id)"></i>
                </template>
            </Column>
            
            <template #footer v-if="viewSetPagamento">
                <div>
                    <div class="p-field col-12">
                        <Button v-for="(type_pay, index) in types_pay" :key="index" :label="type_pay.nome" :class="`m-2 p-button-${type_pay.selected ? 'info' : 'outlined'}`" @click="selectPayment(index, type_pay.id)" />
                    </div>

                    <div class="p-field col-12" v-if="viewTaglie">
                        <Button v-for="(ts, index) in type_size" :key="index" :label="ts.nome" :class="`m-2 p-button-${ts.selected ? 'info' : 'outlined'}`" @click="selectSize(index, ts.id)" />
                    </div>
                    
                    <div class="col-12 flex justify-content-between" style="font-size: 2rem;">
                        <div class="col-4 flex justify-content-between">
                            <p>Totale: € {{ pagamento.totale }}</p>
                        </div>
                        <div class="">
                            <Calendar :class="['inputfield w-full']" v-model="pagamento.data" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />
                        </div>
                        <div class="col-6 flex justify-content-end">
                            <Button class="p-button-success m-3" icon="pi pi-check" label="Completa pagamento" @click="sendPagamento" :disabled="canSavePagamento"/>
                            <Button class="p-button-info m-3" icon="pi pi-file-pdf" label="Visualizza ricevuta" @click="viewRicevuta" v-if="id_pagamento"/>
                        </div>
                    </div>
                </div>
            </template>
        </DataTable>

        <!-- Dialog per modificare importo e note -->
        <Dialog v-model:visible="dialogModificaVisible" header="Modifica Importo e Note" :modal="true" :style="{ width: '450px' }">
            <div class="p-fluid">
                <div class="p-field" style="margin-bottom: 1.5rem;">
                    <label for="importo">Importo €</label>
                    <InputNumber 
                        id="importo"
                        v-model="modificaData.importo" 
                        mode="currency" 
                        currency="EUR" 
                        locale="it-IT" 
                        autofocus 
                        fluid 
                    />
                </div>
                
                <div class="p-field">
                    <label for="note">Note</label>
                    <Textarea 
                        id="note"
                        v-model="modificaData.note" 
                        rows="4" 
                        autoResize 
                    />
                </div>
            </div>
            
            <template #footer>
                <Button label="Annulla" icon="pi pi-times" @click="dialogModificaVisible = false" class="p-button-text" />
                <Button label="Salva" icon="pi pi-check" @click="salvaModifiche" class="p-button-success" />
            </template>
        </Dialog>

        <Dialog v-model:visible="dialogTorneoVisible" header="Seleziona Torneo" :modal="true" :style="{ width: '400px' }">
            <div class="p-field w-full">
                <label for="torneoSelect">Associa a un torneo (tra quelli convocati)</label>
                <Dropdown 
                    id="torneoSelect"
                    v-model="selectedTorneoId" 
                    :options="athleteTournaments" 
                    optionLabel="nome_torneo" 
                    optionValue="id" 
                    placeholder="Seleziona un torneo" 
                    class="w-full mt-2" 
                />
            </div>
            <template #footer>
                <Button label="Annulla" icon="pi pi-times" @click="dialogTorneoVisible = false" class="p-button-text" />
                <Button label="Salva" icon="pi pi-check" @click="saveTorneo" :disabled="!selectedTorneoId" />
            </template>
        </Dialog>
    </AccordionTab>
                    <AccordionTab header="Pagamenti">
                      <!--  <p v-if="pagamenti.length==0">Non ci sono pagamenti per corsi al momento</p>
                        <DataTable :value="pagamenti" class="p-datatable-gridlines" v-else>
                            <Column field="corso" header="Corso">
                                <template #body="{data}">
                                <Button @click="goToCorso(data.id_corso)" class="p-button-link">{{ data.corso }}</Button>
                            </template>
                                </Column>
                            <Column field="n_rata" header="Rata n.">
                                <template #body="{data}">
                                    {{ data.n_rata }} di {{ data.n_rate }}
                                </template>
                            </Column>
                            <Column field="data_scadenza" header="Data scadenza">
                                <template #body="{data}">
                                    {{ moment(data.data_scadenza).format('DD/MM/Y') }}
                                </template></Column>
                            <Column field="importo" header="Importo"></Column>
                            <Column field="data_pagamento" header="Data pagamento">
                                <template #body="{data}">
                                    {{ moment(data.data_pagamento).format('DD/MM/Y') }}
                                </template>
                            </Column>
                            <Column field="nome_cassa" header="Cassa">
                                <template #body="{data}">
                                    <div class="flex justify-content-between align-items-center">
                                        <p>{{ data.nome_cassa }}</p>
                                            </div>
                                </template>
                            </Column>

                            <Column field="nome_cassa" header="" tyle='width:100px'>
                                <template #body="{data}">
                                    <div class="flex justify-content-between align-items-center">
                                        <Button icon="pi pi-file-pdf" class="p-button-raised p-button-success" text @click="viewRicevuta($event, data.id)" v-tooltip="`Visualizza ricevuta`" />&nbsp;&nbsp;&nbsp;
                                        <Button icon="pi pi-refresh" class="p-button-raised p-button-info" text @click="aggiornaRicevuta($event, data.id)" v-tooltip="`Aggiorna`" style="margin-left:5px;margin-right:5px"/>
                               
                                        <Button icon="pi pi-envelope" class="p-button-raised p-button-warning" text @click="sendRicevuta($event, data.id)" v-tooltip="`Invia ricevuta`"/>
                                    </div>
                                </template>
                            </Column>

                            <Column field="nome_cassa" header="" tyle='width:100px'>
                                <template #body="{data}">
                                    <div class="flex justify-content-between align-items-center">
                                        <Button icon="pi pi-trash" style='color:white' class="p-button-raised p-button-danger p-button-text" text @click="cancellaRicevuta($event, data.id)" v-tooltip="`Cancella`"/>
                            
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                        
                        <p v-if="vendite.length==0">Non ci sono pagamenti al momento</p>
                        <Accordion v-else style='margin-top:10px' >
                            <AccordionTab v-for="vendita in vendite" :key="vendita.id" :header="`N. Vendita: ${vendita.id} del ${moment(vendita.data_vendita).format('DD/MM/Y')} - Totale € ${vendita.totale_pagato} - CASSA ${vendita.cassa}`">
                                <Button icon="pi pi-refresh" class="p-button-raised p-button-info" text @click="aggiornaRicevuta($event, vendita.id_pagamento)" v-tooltip="`Aggiorna`" style="margin-bottom:5px;margin-right:5px"/>
                                <Button icon="pi pi-file-pdf" class="p-button-raised p-button-success" @click="viewRicevuta(evt,vendita.id_pagamento)" style="margin-bottom:5px;margin-right:5px"/>
                                <Button icon="pi pi-trash"  class="p-button-raised p-button-warning p-button-danger" text @click="cancellaRicevuta($event, vendita.id_pagamento)" v-tooltip="`Cancella`" style='color:white;margin-bottom:5px' />
                                <Button label="Invia ricevuta tramite email" raised class="p-button p-button-warning" @click="sendRicevuta(evt,vendita.id_pagamento)" style="margin-bottom:5px;float:right"/>

                                <DataTable :value="vendita.dettaglio" class="p-datatable-gridlines">
                                    <Column field="nome" header="Prodotto"></Column>
                                    <Column field="size" header="Dettaglio"></Column>
                                    <Column field="quantita" header="Quantità"></Column>
                                    <Column field="prezzo" header="Importo"></Column>
                                </DataTable>
                            </AccordionTab>
                        </Accordion>-->


                        <DataTable :value="tuttiIPagamenti" class="p-datatable-gridlines">
    <Column field="tipo" header="Tipo"></Column>
    <Column field="riferimento" header="Riferimento">
        <template #body="{ data }">
            <div v-if="data.id_iscrizione || data.id_corso">
                <Button @click="goToCorso(data.id_corso)" class="p-button-link" v-tooltip="'Vai al corso'">
                    <i class="pi pi-book mr-2"></i> Corso
                </Button>
            </div>
            <div v-else-if="data.id_torneo_ext">
                <Button @click="data.is_convocazione == 1 ? openDialogTorneo(data.id_richiesta_pagamento, data.id_torneo_ext) : $router.push('/tornei')" class="p-button-link" v-tooltip="data.is_convocazione == 1 ? 'Cambia torneo' : 'Vai ai tornei'">
                    <i class="pi pi-trophy mr-2"></i> Torneo
                </Button>
            </div>
            <div v-else-if="data.id_prodotto && data.is_convocazione == 1">
                <Button @click="openDialogTorneo(data.id_richiesta_pagamento, null)" class="p-button-link" v-tooltip="'Associa torneo'">
                   <i class="pi pi-trophy mr-2"></i> Associa Torneo
                </Button>
            </div>
            <div v-else-if="data.id_prodotto">
                <Button @click="$router.push(`/prodotto/${data.id_prodotto}/dettagli`)" class="p-button-link" v-tooltip="'Dettaglio prodotto'">
                   <i class="pi pi-tag mr-2"></i> Prodotto
                </Button>
            </div>
            <div v-else-if="data.id_kit">
                <Button @click="$router.push(`/kit/${data.id_kit}/dettagli`)" class="p-button-link" v-tooltip="'Dettaglio kit'">
                    <i class="pi pi-briefcase mr-2"></i> Kit
                </Button>
            </div>
            <div v-else>-</div>
        </template>
    </Column>

    <Column field="corso" header="Dettaglio">
        <template #body="{ data }">
            <div v-if="data.tipo === 'Corso'">
                <Button @click="goToCorso(data.id_corso)" class="p-button-link">{{ data.corso }}</Button>
            </div>
            <div v-else>
                {{ data.nome }}
            </div>
        </template>
    </Column>

    <Column field="dettaglio" header="Dettaglio" >
        <template #body="{ data }">
            {{ data.size || '' }}
            {{ data.quantita || '' }}
             <span v-if="data.n_rata">{{ data.n_rata }} di {{ data.n_rate }}</span>
            <span v-else></span>
        </template>
    </Column>

   

    <Column field="data_scadenza" header="Scadenza">
        <template #body="{ data }">
            <Button 
                v-if="data.id_richiesta_pagamento"
                class="p-button-link p-button-text" 
                @click="openDialogScadenza(data.id_richiesta_pagamento, data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'), 'data_scadenza')"
            >
                {{ data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/Y') : '...' }}
            </Button>
            <span v-else>
                {{ data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/Y') : '-' }}
            </span>
        </template>
    </Column>

    <Column field="data_prodotto" header="Data Prodotto">
        <template #body="{ data }">
            <Button 
                v-if="data.id_richiesta_pagamento"
                class="p-button-link p-button-text" 
                @click="openDialogScadenza(data.id_richiesta_pagamento, data.data_prodotto ? moment(data.data_prodotto).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'), 'data_prodotto')"
                v-tooltip="'Modifica data prodotto'"
            >
                {{ data.data_prodotto ? moment(data.data_prodotto).format('DD/MM/Y') : '...' }}
            </Button>
            <span v-else-if="data.data_prodotto">
                {{ moment(data.data_prodotto).format('DD/MM/Y') }}
            </span>
            <span v-else>-</span>
        </template>
    </Column>


    <Column field="data_pagamento" header="Data pagamento">
        <template #body="{ data }">
            {{ data.data_pagamento ? moment(data.data_pagamento).format('DD/MM/Y') : '-' }}
        </template>
    </Column>

    <Column field="nome_cassa" header="Cassa">
        <template #body="{ data }">
            {{ data.nome_cassa || data.cassa || '-' }}
        </template>
    </Column>


    <Column field="importo" header="Importo" style='text-align: right'>
        <template #body="{ data }" >
            {{ data.importo || data.prezzo || '' }} € 
        </template>
    </Column>
    
    <Column field="numero_prenotazioni" header="Prenotazioni" style='text-align: center'>
        <template #body="{ data }">
            <span v-if="data.numero_prenotazioni !== undefined && data.numero_prenotazioni !== null && data.numero_prenotazioni > 0">
                <Tag :value="data.numero_prenotazioni.toString()" severity="info" />
            </span>
            <span v-else>-</span>
        </template>
    </Column>
    
    <Column header="Azioni" style="width:250px;">
        <template #body="{ data }">
            <Button v-if="data.id" icon="pi pi-file-pdf" class="p-button-raised p-button-success" text @click="viewRicevuta($event, data.id)" v-tooltip="'Visualizza ricevuta'"/>
            <Button v-if="data.id" icon="pi pi-refresh" class="p-button-raised p-button-info" text @click="aggiornaRicevuta($event, data.id)" v-tooltip="'Aggiorna'" style="margin: 0 5px"/>
            <Button v-if="data.id" icon="pi pi-envelope" class="p-button-raised p-button-warning" text @click="sendRicevuta($event, data.id)" v-tooltip="'Invia ricevuta'"/>
            <Button v-if="data.id" icon="pi pi-trash" class="p-button-raised p-button-danger p-button-text" text @click="confermaCancellazione($event, data.id)" v-tooltip="'Cancella'" style="margin-left:30px;color:white"/>
        </template>
    </Column>
</DataTable>
                    </AccordionTab>    


                       <AccordionTab header="Notifiche">

                        <p v-if="notifiche.length==0">Non ci sono notifiche al momento</p>
                        <DataTable :value="notifiche" class="p-datatable-gridlines" v-else>
                            <Column field="title" header="Titolo">
                               
                            </Column>
                            <Column field="body" header="Testo"></Column>
                            <Column field="creation_time" header="Data">
                                <template #body="{data}">
                                    {{ moment(data.creation_time).format('DD/MM/Y HH:mm') }}
                                </template>
                            </Column>
                            
                        </DataTable>
                    </AccordionTab>

                    <AccordionTab header="Email Inviate">
                        <p v-if="emails.length==0">Non ci sono email inviate al momento</p>
                        <DataTable :value="emails" class="p-datatable-gridlines" v-else>
                            <Column field="creation_time" header="Data">
                                <template #body="{data}">
                                    {{ moment(data.creation_time).format('DD/MM/Y HH:mm') }}
                                </template>
                            </Column>
                            <Column field="title" header="Titolo"></Column>
                            <Column field="info" header="Info"></Column>
                            <Column field="email" header="Email"></Column>
                        </DataTable>
                    </AccordionTab>
                            
                </Accordion>
            </template>
        </Card>
    </div>

    <Dialog header="Seleziona il corso" v-model:visible="showAddCorso" modal>
        <form @submit.prevent="handleSubmitAddCorso">
        <div class="field">
          <label for="file">Corsi disponibili</label><br/>
          <Dropdown v-model="selectedCorso" :options="corsiToAdd" optionLabel="nome"  class="text_toupper inputfield w-full" />
                               
        </div>
        <div class="dialog-footer">
          <Button label="Salva" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>
<Dialog header="Motivi di Blocco" v-model:visible="showMotiviDialog" :modal="true" :style="{width: '30vw'}">
    <div v-if="selectedCorsoMotivi.length === 0">
        <p>Nessun motivo bloccante. Puoi prenotare.</p>
    </div>
    <div v-else>
        <div v-for="(motivo, index) in selectedCorsoMotivi" :key="index" class="mb-2">
            <Checkbox :inputId="'motivo_'+index" v-model="checkedMotivi" :value="motivo" />
            <label :for="'motivo_'+index" class="ml-2">{{ motivo }}</label>
        </div>
    </div>
    <template #footer>
        <Button label="Chiudi" icon="pi pi-times" @click="showMotiviDialog=false" class="p-button-text"/>
    </template>
</Dialog>

    <Dialog header="Aggiungi un kit da acquistare" v-model:visible="showDialogKit" modal>
        <form @submit.prevent="handleSubmitKit">
        <div class="field">
          <label for="file">Seleziona Kit</label><br/>
          <Dropdown v-model="kitToBuy" :options="kits" optionLabel="nome"  class="text_toupper inputfield w-full" />
                               
        </div>
        <div class="field">
          <label for="expirationDate">Data di Scadenza</label>
          <Calendar :class="['inputfield w-full']" v-model="expirationDate" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />

        </div>
        
        <div class="dialog-footer">
          <Button label="Salva" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>

    <Dialog header="Aggiungi un prodotto da acquistare" v-model:visible="showDialogProdotti" modal>
        <form @submit.prevent="handleSubmitProducts">
        <div class="field">
          <label for="file">Seleziona Prodotto</label><br/>
          <Dropdown v-model="prodottoToBuy" :options="products" optionLabel="nome"  class="text_toupper inputfield w-full" @change="changeProdottoToBuy($event,data)"/>
                               
        </div>
        <div class="field"  v-if='!showexpirationDateProduct'>
          <label for="expirationDate">Data di Scadenza</label>
          <Calendar :class="['inputfield w-full']" v-model="expirationDate" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />

        </div>
        <div class="field" v-if='showexpirationDateProduct'>
          <label for="expirationDateProduct">Data di Scadenza Prodotto</label>
          <Calendar :class="['inputfield w-full']" v-model="expirationDateProduct" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />

        </div>
        <div class="field" v-if="giorni">
        <label>Seleziona fino a 4 giorni</label>
        <div class="flex flex-wrap gap-2">
            <div v-for="(day, index) in weekDays" :key="index">
            <Checkbox v-model="selectedDays" :inputId="'day-' + index" :value="day" @change="limitSelection" />
            <label :for="'day-' + index">{{ day }}</label>
            </div>
        </div>
        </div>  
        <div class="field" v-if='showNote'>
          <label for="note">Note</label>
          <InputText :class="['inputfield w-full']" v-model="noteProduct" />

        </div>
        <div class="field" v-if='showNote'>
          <label for="note">Importo</label>
          <InputText :class="['inputfield w-full']" v-model="importoProduct" />

        </div>
        <div class="field" v-if='prodottoToBuy && prodottoToBuy.isAcconto == 1'>
          <label for="iscrizione">Associa a Corso (opzionale)</label>
          <Dropdown v-model="selectedIscrizioneAcconto" :options="corsi" optionLabel="nome_corso" optionValue="id_iscrizione" placeholder="Seleziona un corso" class="text_toupper inputfield w-full" showClear />
        </div>
        <div class="field" v-if='prodottoToBuy && prodottoToBuy.isAcconto == 1'>
          <label for="torneo">Associa a Torneo (opzionale)</label>
          <Dropdown v-model="selectedTorneoAcconto" :options="athleteTournaments" optionLabel="nome_torneo" optionValue="id" placeholder="Seleziona un torneo" class="text_toupper inputfield w-full" showClear />
        </div>
        <div class="field" v-if='prodottoToBuy && prodottoToBuy.isAcconto == 1'>
          <label for="prodotto">Associa a Prodotto (opzionale)</label>
          <Dropdown v-model="selectedProdottoAcconto" :options="athleteProducts" optionLabel="nome" optionValue="id" placeholder="Seleziona un prodotto" class="text_toupper inputfield w-full" showClear />
        </div>
        <div class="field" v-if='prodottoToBuy && prodottoToBuy.isAcconto == 1'>
          <label for="kit">Associa a Kit (opzionale)</label>
          <Dropdown v-model="selectedKitAcconto" :options="athleteKits" optionLabel="nome" optionValue="id" placeholder="Seleziona un kit" class="text_toupper inputfield w-full" showClear />
        </div>
        <div class="dialog-footer">
          <Button label="Salva" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>

    <Dialog header="Carica File" v-model:visible="showDialogCaricaFile" modal>
      <form @submit.prevent="handleSubmit">
        <div class="field">
          <label for="file">Seleziona File</label><br/>
          <input type="file" id="file" @change="handleFileChange" required />
        </div>
        
        <div class="field">
          <label for="type">Tipologia</label>
          <Dropdown v-model="type" :options="typeofFiles" optionLabel="nome" class="text_toupper inputfield w-full" />
                            
        </div>
        
        <div class="field">
          <label for="expirationDate">Data di Scadenza</label>
          <Calendar :class="['inputfield w-full']" v-model="expirationDate" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />

        </div>
        
        <div class="dialog-footer">
          <Button label="Salva" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>

    <Dialog header="Modifica Documento" v-model:visible="showDialogModificaDoc" modal :style="{width: '450px'}">
      <form @submit.prevent="handleUpdateDoc">
        <div class="p-fluid">
          <div class="field">
            <label for="edit_type">Tipologia</label>
            <Dropdown v-model="edit_type" :options="typeofFiles" optionLabel="nome" class="text_toupper inputfield w-full" />
          </div>
          
          <div class="field">
            <label for="edit_expirationDate">Data di Scadenza</label>
            <Calendar :class="['inputfield w-full']" v-model="edit_expirationDate" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />
          </div>
        </div>
        
        <div class="dialog-footer mt-4">
          <Button label="Annulla" icon="pi pi-times" @click="showDialogModificaDoc = false" class="p-button-text" />
          <Button label="Salva" icon="pi pi-check" type="submit" class="p-button-success" />
        </div>
      </form>
    </Dialog>

    <Dialog header="Conferma Cancellazione Documento" v-model:visible="isDialogVisibleDoc" :modal="true" :style="{width: '350px'}">
        <div class="confirmation-content flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span>Sei sicuro di voler eliminare questo documento?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" @click="isDialogVisibleDoc = false" class="p-button-text" />
            <Button label="Sì" icon="pi pi-check" @click="confirmRemoveDoc" class="p-button-danger" autofocus />
        </template>
    </Dialog>

    <Dialog header="Completa Iscrizione" v-model:visible="showDialogCompletaIscrizione" modal>
        <div class="flex col-12">
            <Button v-for="(mensilita, index) in mensilita_da_completare" :key="index" style="position:relative;" :class="`m-2 card p-button-${mensilita.selected ? 'info' : 'outlined'}`" @click="onSelectRata($event, index)">
                <div class="flex flex-column justify-content-center w-14rem">
                    <h3>€ {{ mensilita.importo * mensilita.n_rate }}</h3>
                    <p>
                        {{ mensilita.n_rate }} {{ mensilita.suffix }} da <b style="font-size: 20px;">{{ mensilita.importo }} €</b>
                    </p>
                    <h5>Piano {{ mensilita.descrizione }}</h5>
                </div>
            </Button>

        </div>
        Inserire l'importo della rata

                                    <InputNumber  v-model="importorata" :class="['text_toupper inputfield w-full']" />
        
        Da quando inizia a pagare?
        <div class="mt-5 mr-5 col-12 flex justify-content-center">
            <div class="month-buttons flex-wrap" v-if="!isWeeklyCourse">
      <button 
        v-for="month in months" 
        :key="month.value"
        @click="selectMonth(month)" 
        :class="['month-btn', selectedMonth === month.value ? 'selected' : '']"
      >
        {{ month.label }}
      </button>
    </div>
    <div class="month-buttons flex-wrap max-h-15rem overflow-y-auto" v-else>
      <button 
        v-for="week in weeks" 
        :key="week.value"
        @click="selectWeek(week)" 
        :class="['month-btn', selectedWeek === week.value ? 'selected' : '']"
      >
        {{ week.label }}
      </button>
    </div>
        </div>
        <div class="mt-5 mr-5 col-12 flex justify-content-center">
            <Button :disabled="!canUpdateIscrizione" class="p-button-success" icon="pi pi-check" label="Salva" @click="updateRateIscrizione"/>
        </div>
    </Dialog>
    <Dialog header="Conferma" v-model:visible="isDialogVisible" modal="true" @hide="isDialogVisible = false">
      <p>Sei sicuro di voler rimuovere questo corso?</p>
      <div class="dialog-footer">
        <Button label="No" @click="isDialogVisible = false" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button icon="pi pi-check" class="p-button-danger" label="Sì" @click="confirmRemoveCorso" />
      </div>
    </Dialog>

    <Dialog header="Conferma" v-model:visible="isDialogVisibleToPay" modal="true" @hide="isDialogVisibleToPay = false">
      <p>Sei sicuro di voler rimuovere questo pagamento?</p>
      <div class="dialog-footer">
        <Button label="No" @click="isDialogVisibleToPay = false" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button icon="pi pi-check" class="p-button-danger" label="Sì" @click="confirmRemoveToPay" />
      </div>
    </Dialog>




    <Dialog header="Aggiungi rata" v-model:visible="popupVisible" modal="true" @hide="popupVisible = false">
     
        <h5>Seleziona il corso</h5>
        <p v-for="(m, index) in corsi" :key="index">
            <label>
              <input type="radio" v-model="corsoSelezionato" :value="m" />
              {{ m.nome_corso }} - Inizio: {{ moment(m.data_inizio_corso).format('DD/MM/YYYY') }} - Fine: {{ moment(m.data_fine_corso).format('DD/MM/YYYY') }}
            </label>
          </p>
            <h5>Seleziona la mensilità</h5>
          <p v-for="(m, index) in corsoSelezionato.mensilita" :key="index">
            <label>
              <input type="radio" v-model="mensilitaSelezionata" :value="m" />
              {{ m.descrizione }} - {{ m.importo }}€
            </label>
          </p>
            <h5>Seleziona l'inizio del periodo di competenza</h5>
          <Calendar :class="['inputfield w-full']" v-model="periodoSelezionato" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" />
          <h5>Seleziona il numero di rata</h5>
           <InputNumber v-model="numeroRataSelezionata" :min="1" :max="10" class="inputfield w-full" />
           <hr/>

       <div class="dialog-footer"> <Button icon="pi pi-check" @click="confermaSelezione" label="Conferma" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button @click="popupVisible = false" class="p-button-danger" label="Chiudi" />
   </div>
    </Dialog>

     <Dialog
    header="Invia Notifica all'Utente"
    v-model:visible="showNotificationDialog"
    modal
  >
    <div class="p-fluid">
      <div class="field">
        <label for="notificationTitle">Titolo</label>
        <InputText id="notificationTitle" v-model="notification.title" />
      </div>
      <div class="field">
        <label for="notificationBody">Messaggio</label>
        <Textarea
          id="notificationBody"
          v-model="notification.body"
          rows="5"
          cols="30"
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeSendNotificationDialog"
      />
      <Button
        label="Invia"
        icon="pi pi-send"
        @click="sendNotification"
        :disabled="!notification.title || !notification.body"
      />
    </template>
  </Dialog>




  <Dialog 
      :header="scadenzaFieldType === 'data_prodotto' ? 'Modifica data prodotto' : 'Modifica data di scadenza'" 
      v-model:visible="scadenzaDialogVisible" 
      :modal="true" 
      :closable="true" 
      :style="{ width: '30rem' }"
    >
      <div class="p-fluid">
        <div class="field">
          <label for="newScadenza">{{ scadenzaFieldType === 'data_prodotto' ? 'Nuova data prodotto' : 'Nuova scadenza' }}</label>
          <Calendar 
            id="newScadenza" 
            v-model="nuovadatascadenza" 
            dateFormat="dd/mm/yy" 
            showIcon
          />
        </div>
      </div>

      <template #footer>
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="closeScadenzaDialog" />
        <Button label="Salva" icon="pi pi-check" class="p-button-success" @click="saveScadenza" />
      </template>
    </Dialog>

    <Dialog 
      header="Atleti Associati" 
      v-model:visible="siblingAthletesDialogVisible" 
      :modal="true" 
      :closable="true" 
      :style="{ width: '50rem' }"
    >
      <p class="mb-3">Atleti con lo stesso profilo fiscale:</p>
      <DataTable :value="siblingAthletes" class="p-datatable-gridlines" responsiveLayout="scroll">
        <Column field="cognome" header="Cognome" sortable></Column>
        <Column field="nome" header="Nome" sortable></Column>
        <Column field="datadinascita" header="Data di Nascita">
          <template #body="{data}">
            {{ moment(data.datadinascita).format('DD/MM/YYYY') }}
          </template>
        </Column>
        <Column header="Azioni" style="width: 150px">
          <template #body="{data}">
            <Button 
              label="Apri" 
              icon="pi pi-external-link" 
              class="p-button-sm p-button-info" 
              @click="openAthleteDetail(data.id)" 
            />
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="siblingAthletesDialogVisible = false" />
      </template>
    </Dialog>

    <Dialog header="Conferma invio presentazione" v-model:visible="isDialogVisibleAppPresentation" modal="true" @hide="isDialogVisibleAppPresentation = false">
      <div class="confirmation-content flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span>Sei sicuro di voler inviare la mail di presentazione? <br><b>ATTENZIONE: Verrà resettata la password dell'utente associato.</b></span>
        </div>
      <div class="dialog-footer mt-4">
        <Button label="No" @click="isDialogVisibleAppPresentation = false" class="p-button-text"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button icon="pi pi-check" class="p-button-danger" label="Sì, invia" @click="sendAppPresentation" />
      </div>
    </Dialog>

    <Dialog header="Dividi in 2 rate" v-model:visible="showSplitDialog" :modal="true" :style="{width: '500px'}">
        <div class="p-fluid">
            <div class="field mb-4">
                <label class="font-bold">Totale Originale: € {{ splitData.originalAmount }}</label>
            </div>
            
            <div class="grid">
                <div class="col-6">
                    <div class="field">
                        <label for="acconto">Importo Acconto</label>
                        <InputNumber id="acconto" v-model="splitData.accontoAmount" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                    </div>
                </div>
                <div class="col-6">
                    <div class="field">
                        <label for="scadenza_acconto">Scadenza Acconto</label>
                        <Calendar id="scadenza_acconto" v-model="splitData.accontoDeadline" dateFormat="dd/mm/yy" :showIcon="true" />
                    </div>
                </div>
            </div>

            <div class="grid mt-2">
                <div class="col-6">
                    <div class="field">
                        <label for="saldo">Importo Saldo</label>
                        <InputNumber id="saldo" v-model="splitData.saldoAmount" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                    </div>
                </div>
                <div class="col-6">
                    <div class="field">
                        <label for="scadenza_saldo">Scadenza Saldo</label>
                        <Calendar id="scadenza_saldo" v-model="splitData.saldoDeadline" dateFormat="dd/mm/yy" :showIcon="true" />
                    </div>
                </div>
            </div>
            
            <div v-if="splitTotalMismatch" class="text-danger mt-2 font-bold">
                Attenzione: la somma ({{ (parseFloat(splitData.accontoAmount) + parseFloat(splitData.saldoAmount)).toFixed(2) }}€) non corrisponde al totale!
            </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="showSplitDialog = false" />
            <Button label="Conferma" icon="pi pi-check" :disabled="splitTotalMismatch || splitData.accontoAmount <= 0 || splitData.saldoAmount <= 0" @click="confirmSplit" />
        </template>
    </Dialog>

    <Dialog header="Dettaglio Presenze Giornaliere" v-model:visible="showDailyDetailsDialog" modal :style="{width: '50vw'}">
        <DataTable :value="dailyPresenceData" class="p-datatable-sm p-datatable-gridlines">
            <Column field="data" header="Data" sortable></Column>
            <Column field="ora_inizio" header="Ora Inizio"></Column>
            <Column field="ora_fine" header="Ora Fine"></Column>
            <Column field="campo" header="Campo"></Column>
            <Column field="nome_corso" header="Corso"></Column>
        </DataTable>
        <template #footer>
            <Button label="Chiudi" icon="pi pi-times" @click="showDailyDetailsDialog = false" class="p-button-text"/>
        </template>
    </Dialog>

</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import { useConfirm } from 'primevue/useconfirm'
import { useToast } from 'primevue/usetoast';
export default {
    components: {
        Loader,
    },
    data() {
    return {
      // ... altre variabili
      expandedRows: [], // Inizializza l'array per le righe espanse
      
      
      // ...
    }
    },
  
    setup () { 
        const confirm = useConfirm()
        const toast = useToast();
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        const loading = ref(false)
        const loaded_data = ref(false)
        const update = ref(false);
        const updateUtente = ref(false);
        const dialogModificaVisible = ref(false);
        const submitted = ref(false)
        const validationErrors = ref({})
        const types_pay = ref([])
        const type_size = ref([])
        const selectedIscrizioneAcconto = ref(null);
        const selectedTorneoAcconto = ref(null);
        const selectedProdottoAcconto = ref(null);
        const selectedKitAcconto = ref(null);
        const athleteCourses = ref([]);
        const athleteTournaments = ref([]);
        const dialogTorneoVisible = ref(false);
        const selectedTorneoId = ref(null);
        const currentRichiestaId = ref(null);
        const athleteProducts = ref([]);
        const athleteKits = ref([]);
        const isDialogVisible = ref(false); // Stato per la visibilità del dialogo
        const isDialogVisibleToPay = ref(false); // Stato per la visibilità del dialogo
        const isDialogVisibleDoc = ref(false); // Stato per la visibilità del dialogo di cancellazione documenti
        const isDialogVisibleAppPresentation = ref(false); // Stato per la visibilità del dialogo di conferma invio mail

        const selectedDocId = ref(null); // ID del documento selezionato
        const noteProduct = ref();
        const importoProduct = ref();
        const genders = [
        {key:0, name:'Maschio'},
        {key:1, name:'Femmina'}
        ]
        const citta = ref([])
        const corsiToAdd = ref([])
        const showDialogCaricaFile = ref(false);
        const showDialogModificaDoc = ref(false);
        const showDialogProdotti = ref(false);
        const showNote = ref(false)
        const showDialogKit = ref(false);
        const showDialogCompletaIscrizione = ref(false);
        const file = ref(null);
        const type = ref('');
        const edit_type = ref('');
        const showexpirationDateProduct = ref(false);
        const showAddCorso = ref(false)
        const expirationDate = ref('');
        const edit_expirationDate = ref('');
        const expirationDateProduct = ref('');
        const users = ref([])
        const typeofFiles = ref([])
        const products = ref([])
        const kits = ref([])
        const prodottoToBuy = ref()
        const kitToBuy = ref()
        const prenotazioni = ref([])
        const siblingAthletes = ref([])
        const siblingAthletesDialogVisible = ref(false)
        
        const atleta = ref({})
        const utente = ref({})
        const corsi = ref([])
        const notifiche = ref([])
        const emails = ref([])
        const vendite = ref([])
        const pagamenti = ref([])
        const docs = ref([])
        const numeroRataSelezionata = ref(1);
        const dapagare = ref([])
        const figc = ref([])
        const route = useRoute()
        const id = route.params.id
        const totalToPay = ref(0);
        const lifeTime = 3000;
        const importorata =ref(0)
        const totalPaid = ref(0);
        const pagamento = ref({
            'richieste_pagamenti': [],
            'type_pay': null,
            'totale': 0,
            "data":moment(new Date()).format('DD/MM/YY'),
            'id_atleta': id
        })
        const modificaData= ref( {
                id: null,
                importo: 0,
                note: ''
            });
        

        const showMotiviDialog = ref(false);
        const selectedCorsoMotivi = ref([]);
        const checkedMotivi = ref([]);
        const popupVisible = ref(false)
        const corsoSelezionato = ref(null)
        const mensilitaSelezionata = ref(null)
        const periodoSelezionato = ref(null)
        const aggregatePresenceData = ref([])

        console.log("pagamento");
        console.log(pagamento);
        const setPagamentoDialog = ref(false)
        const metaKey = ref(true)
        const id_pagamento = ref()
        const selectedCorso = ref()
        const giorni = ref(false); // Controllo per la visibilità della selezione giorni
        const selectedDays = ref([]);
        const weekDays = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];
        const limitSelection = () => {
        if (selectedDays.value.length > 4) {
            selectedDays.value.pop(); // Rimuove l'ultimo selezionato se supera il limite
        }
        };
        const months = [
  { label: 'Settembre', value: 8 },
  { label: 'Ottobre', value: 9 },
  { label: 'Novembre', value: 10 },
  { label: 'Dicembre', value: 11 },
  { label: 'Gennaio', value: 0 },
  { label: 'Febbraio', value: 1 },
  { label: 'Marzo', value: 2 },
  { label: 'Aprile', value: 3 },
  { label: 'Maggio', value: 4 },
  { label: 'Giugno', value: 5 }
];

const showNotificationDialog = ref(false);
const scadenzaDialogVisible = ref(false);
const nuovadatascadenza = ref('');
const selecteddapagare = ref(null);
const scadenzaFieldType = ref('data_scadenza');
    const notification = ref({
      title: '',
      body: ''
    });

    const showSplitDialog = ref(false);
    const splitData = ref({
        id: null,
        originalAmount: 0,
        accontoAmount: 0,
        accontoDeadline: null,
        saldoAmount: 0,
        saldoDeadline: null
    });


   const openDialogModificaImporto = (data) => {
            modificaData.value = {
                id: data.id,
                importo: data.importo,
                note: data.note || ''
            };
            dialogModificaVisible.value = true;
        };
        
      const salvaModifiche = async()=> {
            try {
                const formData = new FormData();
                formData.append('importo', modificaData.value.importo);
                formData.append('note', modificaData.value.note);
                await service.salvaModificaImporto(modificaData.value.id,formData).then((res) => {  
                    
                    
                    // Aggiorna i dati localmente
                    const item = dapagare.value.find(d => d.id === modificaData.value.id);
                    if (item) {
                        item.importo = modificaData.value.importo;
                        item.note = modificaData.value.note;
                    }
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    } 
                });
                modificaData.value.id = null;
                modificaData.value.importo = 0;
                modificaData.value.note = '';
                dialogModificaVisible.value = false;
                
            } catch (error) {
                console.error('Errore:', error);
                toast.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Impossibile aggiornare i dati',
                    life: 3000
                });
            }
        };
    // Funzione per aprire il dialog
    const openSendNotificationDialog = () => {
      showNotificationDialog.value = true;
      // Puoi pre-compilare il titolo e il corpo se necessario
      notification.value.title = `Promemoria per ${atleta.value.nome} ${atleta.value.cognome}`;
      notification.value.body = `Ciao, ti ricordiamo che hai un pagamento in scadenza.`;
    };

    // Funzione per chiudere il dialog e resettare i campi
    const closeSendNotificationDialog = () => {
      showNotificationDialog.value = false;
      notification.value.title = '';
      notification.value.body = '';
    };

    const showDailyDetailsDialog = ref(false);
    const dailyPresenceData = ref([]);

    const showDailyDetails = async (id_corso, mese) => {
        loading.value = true;
        try {
            await service.getDailyPresence(id, id_corso, mese).then((res) => {
                dailyPresenceData.value = res.items;
                showDailyDetailsDialog.value = true;
            });
        } catch (error) {
            console.error('Errore nel recupero delle presenze giornaliere:', error);
            toast.add({
                severity: 'error',
                summary: 'Errore',
                detail: 'Impossibile caricare i dettagli delle presenze giornaliere.',
                life: 3000
            });
        } finally {
            loading.value = false;
        }
    };

    const openDialogScadenza = (id, data, fieldType = 'data_scadenza') => {
      scadenzaDialogVisible.value = true;
      nuovadatascadenza.value = data;
      selecteddapagare.value = id;
      scadenzaFieldType.value = fieldType;
    };
 const closeScadenzaDialog = () => {
      scadenzaDialogVisible.value = false;
    };


    const openMotiviDialog = async(idcorso) =>{
            try {
                // qui fai una chiamata API al backend per ottenere i motivi
                await service.check_can_reserve(idcorso,id).then((res) => {
                    console.log(res);
                    selectedCorsoMotivi.value = res.items.can_reserve_motivi || [];
                    checkedMotivi.value = [...selectedCorsoMotivi.value]; // opzionale: li spunti di default
                    showMotiviDialog.value = true;
                    console.log(selectedCorsoMotivi.value);
                });
            } catch (error) {
                console.error(error);
                selectedCorsoMotivi.value = ['Errore nel caricamento motivi'];
                showMotiviDialog.value = true;
            }
        }
    // Funzione per inviare la notifica
    const sendNotification = async () => {

            const formData = new FormData();
            formData.append('user_id',atleta.value.utente.id);
            formData.append('title',notification.value.title);
            formData.append('body', notification.value.body);
            console.log(formData);
            
            try {
                await service.saveNotifica(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    } 
                     getNotifiche()
                });
            } catch (error) {
                alert('Errore nel caricamento del prodotto.');
            }
          closeSendNotificationDialog();

    };

function confermaCancellazione(evt, id) {
  confirm.require({
    target: evt.currentTarget,
    message: 'Sei sicuro di voler cancellare la ricevuta?',
    header: 'Conferma cancellazione',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sì',
    rejectLabel: 'No',
    accept: () => {
      cancellaRicevuta(evt,id)
    }
  })
}

const tuttiIPagamenti = computed(() => {
  const pagamentiCorsi = pagamenti.value.map(p => ({
    tipo: 'Corso',
    ...p
  }))

  const pagamentiVendite = vendite.value.flatMap(v =>
    v.dettaglio.map(item => ({
      tipo: 'Vendita',
      nome: item.nome,
      size: item.size,
      quantita: item.quantita,
      prezzo: item.prezzo,
      data_pagamento: v.data_vendita,
      data_scadenza: item.data_scadenza,
      cassa: v.cassa,
      id: v.id_pagamento,
      numero_prenotazioni: item.numero_prenotazioni,
      id_prodotto: item.idprodotto,
      id_richiesta_pagamento: item.cod_richieste_pagamenti,
      id_iscrizione: item.id_iscrizione,
      id_torneo_ext: item.id_torneo_ext,
      id_kit: item.id_kit,
      data_prodotto: item.data_prodotto,
      is_convocazione: item.is_convocazione,
      id_corso: item.id_corso
    }))
  )

  return [...pagamentiCorsi, ...pagamentiVendite]
})

// Metodo per mostrare colonne condizionalmente
const rowHasField = field => {
  return tuttiIPagamenti.value.some(p => p[field] !== undefined)
}

const splitTotalMismatch = computed(() => {
    return Math.abs(parseFloat(splitData.value.originalAmount) - (parseFloat(splitData.value.accontoAmount) + parseFloat(splitData.value.saldoAmount))) > 0.01;
});

const openSplitDialog = (data) => {
    splitData.value = {
        id: data.id,
        originalAmount: data.importo,
        accontoAmount: parseFloat((data.importo / 2).toFixed(2)),
        accontoDeadline: data.data_scadenza ? moment(data.data_scadenza).toDate() : new Date(),
        saldoAmount: parseFloat((data.importo - (data.importo / 2)).toFixed(2)),
        saldoDeadline: data.data_scadenza ? moment(data.data_scadenza).toDate() : new Date()
    };
    showSplitDialog.value = true;
};

const confirmSplit = async () => {
    loading.value = true;
    try {
        const payload = {
            id: splitData.value.id,
            acconto_importo: splitData.value.accontoAmount,
            acconto_scadenza: moment(splitData.value.accontoDeadline).format('DD/MM/YYYY'),
            saldo_importo: splitData.value.saldoAmount,
            saldo_scadenza: moment(splitData.value.saldoDeadline).format('DD/MM/YYYY')
        };
        
        await service.splitPayment(payload).then((res) => {
            if (!res || !res.item) return;
            let severity = res.item.esito;
            let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo';
            let detail = res.item.messaggio;
            
            toast.add({severity: severity, summary: summary, detail: detail, life: lifeTime});
            
            if (severity === 'success') {
                showSplitDialog.value = false;
                getDaPagare();
            }
        });
    } catch (error) {
        console.error('Errore durante lo split:', error);
        toast.add({severity: 'error', summary: 'Errore', detail: 'Impossibile completare lo split', life: lifeTime});
    } finally {
        loading.value = false;
    }
};
const selectedMonth = ref(null);
const selectedWeek = ref(null);
const inizioCorso = ref(null);
const coursesMonthlyData = ref({});
const coursesMonthlyDataOLD = ref({});
// Puoi definire qui altre variabili ref o reactive necessarie per il tuo componente

const isWeeklyCourse = computed(() => {
  return iscrizione_da_aggiornare.value.iscrizione && 
         iscrizione_da_aggiornare.value.iscrizione.mensilita && 
         Object.values(iscrizione_da_aggiornare.value.iscrizione.mensilita).some(m => m.descrizione === 'settimanale');
});

const weeks = computed(() => {
  if (!isWeeklyCourse.value) return [];
  const list = [];
  const startStr = iscrizione_da_aggiornare.value.iscrizione.data_inizio_corso; 
  const endStr = iscrizione_da_aggiornare.value.iscrizione.data_fine_corso;
  
  if (!startStr || !endStr) return [];
  
  const start = moment(startStr);
  const end = moment(endStr);
  
  const current = start.clone();
  if (current.day() !== 1) {
    current.day(1);
    if (current.isBefore(start)) {
      current.add(7, 'days');
    }
  }
  
  while (current.isSameOrBefore(end)) {
    list.push({
      label: current.format('DD/MM/YYYY'),
      value: current.format('YYYY-MM-DD')
    });
    current.add(7, 'days');
  }
  return list;
});

const selectMonth = (month) => {
  selectedMonth.value = month.value;
  selectedWeek.value = null;

  const today = new Date();
  const currentMonth = today.getMonth(); // 0 = gennaio, 11 = dicembre
  let year = today.getFullYear();

  if (currentMonth >= 6 && month.value < 6) {
    // Siamo tra luglio (6) e dicembre (11) e selezioniamo un mese tra gennaio (0) e giugno (5)
    year += 1;
  } else if (currentMonth < 6 && month.value >= 6) {
    // Siamo tra gennaio (0) e giugno (5) e selezioniamo un mese tra luglio (6) e dicembre (11)
    year -= 1;
  }

  inizioCorso.value = new Date(year, month.value, 1);

  console.log('Mese di inizio corso selezionato:', inizioCorso.value);

  // Esempio di funzione che utilizza inizioCorso
  elaboraDataInizioCorso();
};

const selectWeek = (week) => {
  selectedWeek.value = week.value;
  selectedMonth.value = null;
  inizioCorso.value = moment(week.value, 'YYYY-MM-DD').toDate();
  console.log('Settimana di inizio corso selezionata:', inizioCorso.value);
};


const openPopup = () => {
  corsoSelezionato.value = corsi.value[0]
  mensilitaSelezionata.value = null
  popupVisible.value = true
}
const confermaSelezione = () => {
    if (mensilitaSelezionata.value) {
        // Puoi gestire qui la selezione (es. salvare nel backend o aggiornare lo stato)
        console.log('Mensilità selezionata:', mensilitaSelezionata.value)
        if (periodoSelezionato.value) {
            console.log('Periodo selezionato:', periodoSelezionato.value)
            handleSubmitNuovaRata();
            popupVisible.value = false
        } else {
            toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Seleziona un periodo prima di confermare.',
            life: 3000
        });
            console.error('Nessun periodo selezionato')
        }   
    }else{
        // Mostra un messaggio di errore e avvisa che non è stata selezionata alcuna mensilità
        toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Seleziona una mensilità prima di confermare.',
            life: 3000
        });
        console.error('Nessuna mensilità selezionata')
    }
}


     const handleSubmitNuovaRata = async () => {
            const formData = new FormData();
            formData.append('importo', mensilitaSelezionata.value.importo);
            formData.append('n_rata', numeroRataSelezionata.value);
            formData.append('id_atleta',id);
            formData.append('iscrizione', corsoSelezionato.value.id_iscrizione);
            formData.append('data_scadenza', moment(periodoSelezionato.value,'DD/MM/YYYY'));
            console.log(formData);
            
            try {
                await service.sendRataToAdd(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    } 
                });
            } catch (error) {
                alert('Errore nel caricamento del prodotto.');
            }
            getDaPagare()
            
        }
const fetchMonthlyPresenceDataOLD = async () => {
      try {
        await service.getMonthlyPresenceOLD(id).then((res) => {
            console.log("coursesMonthlyDataOLD");
            console.log(res);
            coursesMonthlyDataOLD.value = res.items;
            console.log(coursesMonthlyDataOLD.value);
        });
      } catch (error) {
       console.error('Errore nel fetching dei dati di presenza mensili:', error);
       
      } finally {
        console.log("done");
      }
    };  
const fetchMonthlyPresenceData = async () => {
      try {
        await service.getMonthlyPresence(id).then((res) => {
            console.log("fetchMonthlyPresenceData");
            console.log(res);
            coursesMonthlyData.value = res.items.courses || {};
            aggregatePresenceData.value = res.items.aggregate || [];
            console.log(coursesMonthlyData.value);
        });
      } catch (error) {
        console.error('Errore nel fetching dei dati di presenza mensili:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile caricare i dati di presenza mensili.',
          life: 3000,
        });
      } finally {
        fetchMonthlyPresenceDataOLD()
        getNotifiche()
      }
    };  




const elaboraDataInizioCorso = () => {
  if (!inizioCorso.value) return;
  
  // Esempio: formattare la data per visualizzazione
  const formattedDate = `${inizioCorso.value.getMonth() + 1}/${inizioCorso.value.getFullYear()}`;
  console.log('Data formattata:', formattedDate);
  
  // Qui puoi inserire la tua logica di business
  // Per esempio: chiamare un'API, aggiornare altri stati, calcolare date correlate, ecc.
};
        const gotoVendita = () =>{
            window.open(`/add-store/${id}`)
        }
        const openDialogFiles = () =>{
            getTypesofFiles().then(()=>{
                showDialogCaricaFile.value = true
            })
        }  
        const openDialogProdotti = () =>{
            getProdottiToBuy().then(()=>{
                expirationDate.value=moment().format("01/MM/YYYY");
                showexpirationDateProduct.value=false
                selectedIscrizioneAcconto.value = null
                selectedTorneoAcconto.value = null
                selectedProdottoAcconto.value = null
                selectedKitAcconto.value = null
                
                service.getAthleteAssociations(id).then((res) => {
                    athleteCourses.value = res.items.courses || []
                    athleteTournaments.value = res.items.tournaments || []
                    athleteProducts.value = res.items.products || []
                    athleteKits.value = res.items.kits || []
                    showDialogProdotti.value = true
                    prodottoToBuy.value=null
                })
            })
        }
        const openDialogKit = () =>{
            getKitToBuy().then(()=>{
                showDialogKit.value = true
            })
        }
        const addCorso = () => {
            console.log("addCorso")
            service.getCorsi(id)
            .then((res) => {
                corsiToAdd.value = res.items
                showAddCorso.value=true
            })
        }
        const changeProdottoToBuy = (evt, prop) => {
            console.log(evt);
            let value = evt.value
            if (value.isPacchetto){
                showexpirationDateProduct.value=true
                giorni.value=false
            }else{
                showexpirationDateProduct.value=false
                giorni.value=false
            }
            if (value.isAcconto){
                showNote.value=true
            }else{
                showNote.value=false
            }
            console.log(value)
       
        }
        const onCheckboxChange = (rowData)=> {
            // Toggle the selection state
            rowData.selected = !rowData.selected;
            if (rowData.selected) {
        // Add the item to the array if it is checked
                if (!pagamento.value.richieste_pagamenti.includes(rowData)) {
                    pagamento.value.richieste_pagamenti.push(rowData);
                }
            } else {
                // Remove the item from the array if it is unchecked
                const index = pagamento.value.richieste_pagamenti.indexOf(rowData);
                if (index > -1) {
                    pagamento.value.richieste_pagamenti.splice(index, 1);
                }
            }

            setTotaleVendita()
            if (!Object.keys(pagamento.value.richieste_pagamenti).length) {
                pagamento.value.type_pay = null
                types_pay.value.forEach((type, i) => {
                    type.selected = false
                })
            }
        }
        
        const onCellEditComplete = (event) => {
            let { data, newValue, field } = event;
            console.log(data.value);
            console.log(newValue);
            console.log(field);
            const index = pagamento.value.richieste_pagamenti.indexOf(data.value);
            if (index > -1) {
                pagamento.value.richieste_pagamenti.splice(index, 1);
            }
            setTotaleVendita()
            switch (field) {
                case 'prezzo':
                
                break;
            }
        }
        const mensilita_da_completare = ref()
        const iscrizione_da_aggiornare = ref({
            iscrizione: null,
            id_atleta:id,
            rata:[]
        })

        const handleFileChange = (event) => {
             file.value = event.target.files[0];
        };
        /*const removeCorso = async(iddoc)=>{
            const formData = new FormData();
            formData.append('atleta', id);
            formData.append('id', iddoc);

            try{
                await service.delCorsoAtleta(formData) .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }-
                    getCorsi()
                    getDaPagare()
                });
            }catch(error){
                alert('Errore');

            }
        }*/
        const removeCorso = async(iddoc) => {
            selectedDocId.value = iddoc;
            isDialogVisible.value = true; // Mostra il dialogo di conferma
        };
        const confirmRemoveCorso = async() => {
            const formData = new FormData();
            formData.append('atleta', id);
            formData.append('id', selectedDocId.value);

            try {
                await service.delCorsoAtleta(formData).then((res) => {
                let severity = res.item.esito;
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo';
                let detail = res.item.messaggio;
                if (severity != 'warning') {
                    toast.add({severity: severity, summary: summary, detail: detail, life: lifeTime});                            
                }
                getCorsi();
                getDaPagare();
                });
            } catch (error) {
                alert('Errore');
            } finally {
                isDialogVisible.value = false; // Chiudi il dialogo dopo l'operazione
            }
        };
        const removeToPay = async(iddoc) => {
            selectedDocId.value = iddoc;
            console.log(selectedDocId.value)
            isDialogVisibleToPay.value = true; // Mostra il dialogo di conferma
        };
        const confirmRemoveToPay = async() => {
            const formData = new FormData();
            formData.append('atleta', id);
            formData.append('id', selectedDocId.value);

            try {
                await service.delToPayAtleta(formData).then((res) => {
                let severity = res.item.esito;
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo';
                let detail = res.item.messaggio;
                if (severity != 'warning') {
                    toast.add({severity: severity, summary: summary, detail: detail, life: lifeTime});                            
                }
                getDaPagare();
                });
            } catch (error) {
                alert('Errore');
            } finally {
                isDialogVisibleToPay.value = false; // Chiudi il dialogo dopo l'operazione
            }
        };
        const removeDoc = async(iddoc) => {
            selectedDocId.value = iddoc;
            isDialogVisibleDoc.value = true; // Mostra il dialogo di conferma
        };
        const confirmRemoveDoc = async() => {
            const formData = new FormData();
            formData.append('atleta', id);
            formData.append('id', selectedDocId.value);

            try{
                await service.delDoc(formData) .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    getDocs()
                });
            }catch(error){
                alert('Errore');

            } finally {
                isDialogVisibleDoc.value = false; // Chiudi il dialogo dopo l'operazione
            }
        }
        const handleSubmitAddCorso= async () => {
            
            goToIscrizioneAtleta(selectedCorso.value.id)
        }
        const handleSubmitKit = async () => {
            const formData = new FormData();
            formData.append('kit', kitToBuy.value.id);
            formData.append('id_atleta',id);
            formData.append('expirationDate', moment(expirationDate.value,'DD/MM/YYYY').format('01/MM/YYYY'));

            try {
                await service.sendKitToBuy(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    showDialogKit.value = false
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    } 
                });
            } catch (error) {
                alert('Errore nel caricamento del prodotto.');
            }
            showDialogKit.value = false
            getDaPagare()
        }
        const handleSubmitProducts = async () => {
            const formData = new FormData();
            formData.append('prodotto', prodottoToBuy.value.id);
            formData.append('id_atleta',id);
            formData.append('expirationDate',  moment(expirationDate.value, "DD/MM/YYYY").format('01/MM/YYYY'));
            //formData.append('expirationDate', expirationDate.value);
            formData.append('expirationDateProduct',moment(expirationDateProduct.value, "DD/MM/YYYY").format('DD/MM/YYYY'));
            //formData.append('expirationDateProduct',expirationDateProduct.value);
            formData.append('note',noteProduct.value);
            formData.append('importo',importoProduct.value);
            if (selectedIscrizioneAcconto.value) {
                formData.append('id_iscrizione', selectedIscrizioneAcconto.value);
            }
            if (selectedTorneoAcconto.value) {
                formData.append('id_torneo_ext', selectedTorneoAcconto.value);
            }
            if (selectedProdottoAcconto.value) {
                formData.append('id_prodotto', selectedProdottoAcconto.value);
            }
            if (selectedKitAcconto.value) {
                formData.append('id_kit', selectedKitAcconto.value);
            }
            console.log("formData")
            console.log(formData)
            console.log(expirationDate.value);
         
            try {
                await service.sendProductToBuy(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    showDialogProdotti.value = false
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    } 
                    expirationDate.value=null;
                    expirationDateProduct.value=null;
                    noteProduct.value=null;
                    importoProduct.value=null;
                });
            } catch (error) {
                alert('Errore nel caricamento del prodotto.');
            }
            showDialogProdotti.value = false
            getDaPagare()
        }
        const handleSubmit = async () => {
            if (!file.value || !type.value || !expirationDate.value) {
                alert('Per favore, compila tutti i campi.');
                return;
            }

            const formData = new FormData();
            formData.append('file', file.value);
            formData.append('type', type.value.id);
            formData.append('id_atleta',id);
            formData.append('expirationDate', moment(expirationDate.value,'DD/MM/YYYY').format('YYYY-MM-DD'));

            try {
                await service.sendDoc(formData)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    showDialogCaricaFile.value = false
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    
                });
                
            } catch (error) {
                alert('Errore nel caricamento del file.');
            }
            showDialogCaricaFile.value = false
            getDocs()
        };

        const openEditDocDialog = (data) => {
            getTypesofFiles().then(() => {
                selectedDocId.value = data.id_documento;
                edit_type.value = typeofFiles.value.find(t => t.id === data.cod_type_doc);
                edit_expirationDate.value = data.datascadenza ? moment(data.datascadenza).toDate() : null;
                showDialogModificaDoc.value = true;
            });
        };

        const handleUpdateDoc = async () => {
            if (!edit_type.value || !edit_expirationDate.value) {
                alert('Per favore, compila tutti i campi.');
                return;
            }

            const formData = new FormData();
            formData.append('cod_type_doc', edit_type.value.id);
            formData.append('datascadenza', moment(edit_expirationDate.value).format('YYYY-MM-DD'));

            try {
                await service.updateDoc(selectedDocId.value, formData)
                    .then((res) => {
                        let severity = res.item ? res.item.esito : res.esito || 'success';
                        let summary = severity != 'success' ? 'Attenzione' : 'Successo';
                        let detail = res.item ? res.item.messaggio : res.message || 'Operazione completata';
                        
                        toast.add({severity: severity, summary: summary, detail: detail, life: lifeTime});
                        showDialogModificaDoc.value = false;
                        getDocs();
                    });
            } catch (error) {
                console.error('Error updating document:', error);
                toast.add({severity: 'error', summary: 'Errore', detail: 'Impossibile aggiornare il documento', life: lifeTime});
            }
        };

        const goToIscrizioneAtleta = (idcorso)=>{
            window.open(`/add-iscrizione-atleta/${idcorso}/${id}`,'_self')
        }

function getScadenzaClass(dataScadenza) {
  if (!dataScadenza) return '';
  
  const firstOfMonth = moment().startOf('month');
  const scadenza = moment(dataScadenza);

  if (scadenza.isBefore(firstOfMonth, 'day')) {
    return 'text-danger'; // rosso
  } else if (scadenza.isSame(firstOfMonth, 'month')) {
    return 'text-warning'; // arancio
  }
  return '';
}
        const goToCorso = (id)=> {
            window.open(`/corso/${id}/dettagli`)
        }
        const showIscrizione = (id)=> {
            console.log(id)
            const url= `${process.env.VUE_APP_LEVANTE_API_URL}/api/get-iscrizione/pdf/${id}`;
            
            window.open(url)
        }
        const showUtente = (id) => {
            if (!id || id === -1) return;
            const url = `/utente/${id}/dettagli`;
            window.open(url);
        }
        const showSiblingAthletesDialog = () => {
            siblingAthletesDialogVisible.value = true
        }
        const openAthleteDetail = (athleteId) => {
            window.open(`/atleta/${athleteId}/dettagli`, '_blank')
        }

        const confirmSendAppPresentation = () => {
             isDialogVisibleAppPresentation.value = true;
        }

        const sendAppPresentation = async () => {
             loading.value = true
             let fd = new FormData();
             fd.append('id_atleta', id);
             
             try {
                await service.sendAppPresentation(fd)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                })
             } catch (error) {
                 toast.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Impossibile inviare la presentazione',
                    life: 3000
                });
             } finally {
                 loading.value = false
                 isDialogVisibleAppPresentation.value = false
             }
        }

        const openDialogTorneo = (idRichiesta, idTorneo) => {
            currentRichiestaId.value = idRichiesta;
            selectedTorneoId.value = idTorneo;
            dialogTorneoVisible.value = true;
            getAthleteTournamentsData();
        };

        const saveTorneo = async () => {
            loading.value = true;
            try {
                const payload = {
                    id_richiesta_pagamento: currentRichiestaId.value,
                    id_torneo_ext: selectedTorneoId.value
                };
                await service.saveTorneoExt(payload).then((res) => {
                    let severity = res.item.esito;
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo';
                    let detail = res.item.messaggio;
                    toast.add({ severity: severity, summary: summary, detail: detail, life: lifeTime });
                    if (severity === 'success' || severity === 'info') {
                        dialogTorneoVisible.value = false;
                        getDetails(); // Comprehensive refresh
                    }
                });
            } catch (error) {
                console.error('Error saving tournament:', error);
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile salvare il torneo', life: lifeTime });
            } finally {
                loading.value = false;
            }
        };

        const getSiblingAthletes = async () => {
            if (atleta.value.id_utente && atleta.value.id_utente !== -1) {
                await service.getAtletiByUtente(atleta.value.id_utente)
                .then((res) => {
                    // Filter out the current athlete
                    siblingAthletes.value = res.items.filter(a => a.id !== parseInt(id))
                })
                .catch((error) => {
                    console.error('Error fetching sibling athletes:', error)
                    siblingAthletes.value = []
                })
            } else {
                siblingAthletes.value = []
            }
        }

        const getTypesofFiles = async () => {
            await service.getTypesOfFiles()
            .then((res) => {
                typeofFiles.value = res.items
            })
        }
        const getKitToBuy = async () => {
            await service.getKitToBuy()
            .then((res) => {
                kits.value = res.items
            })
        }
        const getProdottiToBuy = async () => {
            await service.getProdottiToBuy()
            .then((res) => {
                products.value = res.items
            })
        }

        const getUtenti = async () => {
            await service.getUtenti()
            .then((res) => {
                users.value = [{ id: -1, name: "Nessun utente" }, ...res.items];
                getDetails()
            })
        }
        const getPaga = async () => {
            totalPaid.value=0
            await service.getPagamenti('atleta', id)
            .then((res) => {
                pagamenti.value = res.items
                console.log("totalPaid.value")
                console.log(totalPaid.value)
                totalPaid.value = pagamenti.value.reduce((sum, item) => sum + item.importo, 0);
                console.log(totalPaid.value)
                getVendite()
            })
        }
        const getDetailsAccordion = (evt) => {
            let {index} = evt
            switch (index) {
                case 1:
                corsi.value = []
                
                getCorsi()
                break;
                
                default:
                break;
            }
        }
        const getDocs = async () => {
            await service.getDocs(id)
            .then((res) => {
                docs.value = res.items
            }).finally(()=>{
                getPrenotazioni()
                getFigc()
            })
        }
        const getDaPagare = async () => {
            await service.getDaPagare('atleta', id)
            .then((res) => {
                dapagare.value = res.items
                totalToPay.value = dapagare.value.reduce((sum, item) => sum + item.importo, 0);
            }).finally(()=>{
                initPagamento()
                getCorsi()
            })
        }
        const getCorsi = async () => {
            await service.getCorsiAtleta(id)
            .then((res) => {
                corsi.value = res.items
            })
             service.getNotificheAtleta(route.params.id).then((res) => {
                notifiche.value = res.items.notifiche
            })
            service.getEmails(route.params.id).then((res) => {
                emails.value = res.items.emails
            })
        }
         const getFigc = async()=>{
            await service.getFigc(id).then((res) => {
                figc.value = res.items
            })
        }
        const getPrenotazioni = async()=>{
            await service.getPrenotazioni(id).then((res) => {
                prenotazioni.value = res.items
            })
        }
        const getNotifiche = async () => {
            await service.getNotificheAtleta(id)
            .then((res) => {
                console.log("getNotificheAtleta")
                console.log(res.items)
                notifiche.value = res.items.notifiche
            })
        }
        const getAthleteTournamentsData = async () => {
            await service.getAthleteTournaments(id)
            .then((res) => {
                athleteTournaments.value = res.items
            })
        }
        
        const getCitta = async () => {
            await service.getCitta()
            .then((res) => {
                citta.value = res.items
                getUtenti()
            })
        }
        const getVendite = async () => {
            await service.getVendita('atleta', id)
            .then((res) => {
                vendite.value = res.items
                console.log("vendite")
                console.log(vendite.value)
                console.log(totalPaid.value)
                totalPaid.value+= vendite.value.reduce((sum, item) => sum + item.totale_pagato, 0);
               // totalToPay.value-= vendite.value.filter(item => item.dettaglio[0].isAcconto === 1).reduce((sum, item) => sum + item.totale_pagato, 0);
            })
        }
        const onUtenteChange = (event) => {
            if (atleta.value.utente && atleta.value.utente.id !== undefined) {
                atleta.value.id_utente = atleta.value.utente.id;
            } else {
                atleta.value.id_utente = -1;
            }

            if (atleta.value.id_utente && atleta.value.id_utente !== -1 && atleta.value.id_utente !== '-1') {
                service.getDetails('utente', atleta.value.id_utente)
                .then((res) => {
                    if (res && res.items && res.items.length > 0) {
                        utente.value = res.items[0];
                        if (utente.value.datadinascita) {
                            utente.value.datadinascita = moment(utente.value.datadinascita).format('DD/MM/Y');
                        }
                    } else {
                        utente.value = {};
                    }
                    getSiblingAthletes();
                })
                .catch((err) => {
                    console.error('Error fetching utente details:', err);
                    utente.value = {};
                    siblingAthletes.value = [];
                });
            } else {
                utente.value = {};
                siblingAthletes.value = [];
            }
        }

        const getDetails = async () => {
            await service.getDetails('atleta', id)
            .then((res)  => {
                atleta.value = res.items[0]
                if (!atleta.value.photo) {
                    if (!atleta.value.sesso) atleta.value.sesso="";
                    atleta.value.photo = `/images/avatar-${atleta.value.sesso.toLowerCase()}.jpg`
                }
                atleta.value.datadinascita = moment(atleta.value.datadinascita).format('DD/MM/Y')
                if (atleta.value.sesso && genders.find(gender => gender.name.startsWith(atleta.value.sesso.toUpperCase()))) {
                    atleta.value.sesso = genders.find(gender => gender.name.startsWith(atleta.value.sesso.toUpperCase())).name
                }
                
                // Match or fallback user dropdown
                if (atleta.value.id_utente !== undefined && atleta.value.id_utente !== null) {
                    atleta.value.utente = users.value.find(user => user.id == atleta.value.id_utente)
                }
                if (!atleta.value.utente) {
                    atleta.value.utente = users.value.find(user => user.id == -1) || { id: -1, name: "Nessun utente" };
                    atleta.value.id_utente = -1;
                }

                atleta.value.comune = citta.value.find(comune => comune.id == atleta.value.cod_comune)

                if (atleta.value.id_utente && atleta.value.id_utente != -1 && atleta.value.id_utente != '-1') {
                    service.getDetails('utente', atleta.value.id_utente)
                    .then((res) => {
                        if (res && res.items && res.items.length > 0) {
                            utente.value = res.items[0]
                            if (utente.value && utente.value.datadinascita) {
                                utente.value.datadinascita = moment(utente.value.datadinascita).format('DD/MM/Y')
                            }
                        } else {
                            utente.value = {}
                        }
                        loaded_data.value = true
                        getSiblingAthletes()
                    })
                    .catch((err) => {
                        console.error('Error fetching utente details:', err)
                        utente.value = {}
                        loaded_data.value = true
                    })
                } else {
                    utente.value = {}
                    siblingAthletes.value = []
                    loaded_data.value = true
                }
            })
        }
        const validateForm = () => {
            let regexCf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
            
            // Sync id_utente with selected utente dropdown
            if (atleta.value.utente && atleta.value.utente.id !== undefined) {
                atleta.value.id_utente = atleta.value.utente.id;
            } else if (atleta.value.id_utente === null || atleta.value.id_utente === undefined) {
                atleta.value.id_utente = -1;
            }

            // Validazione atleta
            let validate_properties = [
                'nome',
                'cognome',
                'datadinascita',
                'sesso',
                'id_utente'
            ]
            validate_properties.forEach( prop => {
                if (prop === 'id_utente') {
                    if (atleta.value[prop] === '' || atleta.value[prop] === null || atleta.value[prop] === undefined) {
                        validationErrors.value[prop] = true
                    } else {
                        delete validationErrors.value[prop];
                    }
                } else if (atleta.value[prop] == '' || atleta.value[prop] == null) {
                    validationErrors.value[prop] = true
                } else {
                    delete validationErrors.value[prop];
                    if (prop == 'codfis') {
                        if (!regexCf.test(atleta.value[prop])) {
                            validationErrors.value[prop] = true
                        }
                    }
                }
            })
            // Fine Validazione atleta
            
            return !Object.keys(validationErrors.value).length;
        }
        const setDataTime = (el) => {
            if (typeof el == 'object') {
                return moment(el).format('DD/MM/YYYY')                
            }
            let dataPart = el.split('/')
            el = `${dataPart[2]}-${dataPart[1]}-${dataPart[0]}`
            return el
        } 
        
        const sendNewDataAtleta = () => {
            submitted.value = true;
            validationErrors.value = []
            
            if (atleta.value.utente && atleta.value.utente.id !== undefined) {
                atleta.value.id_utente = atleta.value.utente.id;
            } else if (!atleta.value.id_utente) {
                atleta.value.id_utente = -1;
                atleta.value.utente = users.value.find(u => u.id === -1) || { id: -1, name: "Nessun utente" };
            }

            if(validateForm()){
                // loading.value = true
                let fd = new FormData();
                atleta.value.birth = setDataTime(atleta.value.datadinascita)
                
                fd.append('atleta', JSON.stringify(atleta.value));
                
                service.sendNewDataAtleta(fd)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    
                    update.value = res.item.esito == 'danger' ? true : false
                })
            }else{
                update.value = true
                toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`,life:lifeTime});
            }
            
        }
        const validateFormUtente = () => {
            let regexCf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
            
            // Validazione atleta
            let validate_properties = [
            'nome',
            'cognome',
            'telefono',
            'username'
           
            ]
            validate_properties.forEach( prop => {
                if (utente.value[prop] == '' || utente.value[prop] == null) {
                    validationErrors.value[prop] = true
                } else {
                    delete validationErrors.value[prop];
                    if (prop == 'codfis') {
                        if (!regexCf.test(utente.value[prop])) {
                            validationErrors.value[prop] = true
                        }
                    }
                }
            })
            // Fine Validazione atleta
            
            return !Object.keys(validationErrors.value).length;
        }
        const changeUpdate = () => {
            if (!update.value) {
                sendNewDataAtleta()
            }
        }
        const sendNewDataUtente = () => {
            submitted.value = true;
            validationErrors.value = []
            if(validateFormUtente()){
                // loading.value = true
                let fd = new FormData();
                utente.value.birth = setDataTime(utente.value.datadinascita)
                
                fd.append('utente', JSON.stringify(utente.value));
                
                service.sendNewDataUtente(fd)
                .then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    
                    updateUtente.value = res.item.esito == 'danger' ? true : false
                })
            }else{
                updateUtente.value = true
                toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`,life:lifeTime});
            }
            
        }
        const changeUpdateUtente = () => {
            if (!updateUtente.value) {
                sendNewDataUtente()
            }
        }
        const setPagamento = () => {
            setPagamentoDialog.value = true
        }
        const getPromises = (promises) => {
            loading.value = true
            
            Promise.all(promises)
            .then(()=>{
                
            }).finally(()=>{
                loading.value = false
            })
        }
        
        const viewSetPagamento = computed(()=>{
            return Object.keys(pagamento.value.richieste_pagamenti).length
        })
 
        const viewTaglie = computed(()=>{
            var quanti= Object.keys(pagamento.value.richieste_pagamenti).length
            console.log(quanti);
            for(var i=0;i<quanti;i++){
                if (Object.keys(pagamento.value.richieste_pagamenti[i]) && pagamento.value.richieste_pagamenti[i].kit)
                    return true;
            }
            return false;
        })
   
        const getTypePay = async () => {
            await service.getTypePay()
            .then((res) => {
                types_pay.value = res.items
                types_pay.value.forEach(type => {
                    type.selected = false
                })
                getTypeTaglie()
            })
        }
        const getTypeTaglie = async () => {
            await service.getSizes()
            .then((res) => {
                type_size.value = res.items
                type_size.value.forEach(type => {
                    type.selected = false
                })
                fetchMonthlyPresenceData()
            })
        }
        const selectPayment = (index, id) => {
            pagamento.value.type_pay = id
            types_pay.value.forEach((type, i) => {
                type.selected = i == index ? true : false
            })
        }
        const selectSize = (index, id) => {
            pagamento.value.type_size = id
            type_size.value.forEach((type, i) => {
                type.selected = i == index ? true : false
            })
        }

        const sendPagamento = () => {
            loading.value = true
            let fd = new FormData();
            pagamento.value.data=moment(pagamento.value.data,'DD/MM/YYYY').format('DD/MM/YYYY')
            fd.append('pagamento', JSON.stringify(pagamento.value));
            
            service.sendPagamento(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                if (severity != 'warning') {
                    toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});  
                    if (severity == 'success') {
                        id_pagamento.value = res.item.dati.id_pagamento
                    }                          
                }
            }).finally(()=>{
                getPaga()
                getDaPagare()
                loading.value = false
            })
        }

        const initPagamento = () => {
            pagamento.value = {
                'type_pay': null,
                'type_size':null,
                'richieste_pagamenti': [],
                'totale': 0,
                'id_atleta':id,
                "data":moment(new Date()).format('DD/MM/YYYY'),
            }
        }
        const setTotaleVendita = () => {
            let totale = 0
            pagamento.value.richieste_pagamenti.forEach(prodotto => {
                totale += prodotto.importo
            })
            pagamento.value.totale = totale
        }

        const onRowSelect = (event) => {
            setTotaleVendita()
            if (!Object.keys(pagamento.value.richieste_pagamenti).length) {
                pagamento.value.type_pay = null
                types_pay.value.forEach((type, i) => {
                    type.selected = false
                })
            }
        }

        const canSavePagamento = computed(()=>{
            return !(Object.keys(pagamento.value.richieste_pagamenti).length && pagamento.value.type_pay)
        })

        const sendRicevuta= async (evt, id = id_pagamento.value) => {
            loading.value = true
            let fd = new FormData()
            await service.sendRicevuta(id,fd)
            .then((res)=> {
                // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});  
            })
            .finally(()=>{
                id_pagamento.value = null
                loading.value = false
            })
        }

        const aggiornaRicevuta= async (evt, id) => {
            loading.value = true
            console.log("aggiornaRicevuta");
            let fd = new FormData()
            await service.aggiornaRicevuta(id,fd)
            .then((res)=> {
                // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});  
            })
            .finally(()=>{
                loading.value = false
            })
        }

        const saveScadenza = async (evt, id) => {
            loading.value = true
            console.log("saveScadenza");
            let fd = new FormData()
            fd.append('id_richiesta_pagamento', selecteddapagare.value)
            fd.append('data_scadenza', moment(nuovadatascadenza.value,'DD/MM/YYYY').format('YYYY-MM-DD'))
            fd.append('campo', scadenzaFieldType.value)
            await service.saveScadenza(fd)
            .then((res)=> {
                // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});  
            })
            .finally(()=>{
                getDaPagare()
                getPaga()
                nuovadatascadenza.value = null
                selecteddapagare.value = null
                scadenzaFieldType.value = 'data_scadenza'
                loading.value = false
                closeScadenzaDialog();
            })
        }
        
        const cancellaRicevuta= async (evt, id) => {
            loading.value = true
            console.log("cancellaRicevuta");
            let fd = new FormData()
            await service.cancellaRicevuta(id,fd)
            .then((res)=> {
                // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});  
            })
            .finally(()=>{
                getDaPagare()
                getPaga()
                getDocs()
                id_pagamento.value = null
                loading.value = false
            })
        }

        const viewRicevuta = async (evt, id = id_pagamento.value) => {
            loading.value = true
            let fd = new FormData()
            fd.append('id_pagamento', id)
            await service.viewRicevuta(fd)
            .then((res)=> {
                // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
                let pdfContents = res.item;
                if (pdfContents == 'Non ci sono documenti') {
                    toast.add({severity:'warn', summary:'Errore documenti', detail: pdfContents});
                } else {
                    pdfContents.forEach(pdf => {
                        const pdfContent = pdf[0]
                        const pdfType = pdf[1]
                        
                        const decodedData = Uint8Array.from(atob(pdfContent), c => c.charCodeAt(0));
                        const blob = new Blob([decodedData], { type: pdfType });
                        const pdfUrl = URL.createObjectURL(blob);
                        // Apri l'URL di dati in una nuova finestra del browser
                        
                        window.open(pdfUrl);
                    });          
                }
            })
            .finally(()=>{
                getDaPagare()
                getPaga()
                getDocs()
                types_pay.value.forEach(type => {
                    type.selected = false
                })
                id_pagamento.value = null
                loading.value = false
            })
        }

        const setRate = (data) => {
            mensilita_da_completare.value = data.mensilita
            iscrizione_da_aggiornare.value.iscrizione = data
            selectedMonth.value = null
            selectedWeek.value = null
            inizioCorso.value = null
            showDialogCompletaIscrizione.value = true
        }

        const resetPagamenti = (data) => {
            confirm.require({
                message: 'Sei sicuro di voler reimpostare i pagamenti? Verranno cancellate tutte le richieste di pagamento (non saldate) per questa iscrizione.',
                header: 'Conferma reimpostazione',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    loading.value = true
                    let fd = new FormData();
                    fd.append('id_iscrizione', data.id_iscrizione);
                    
                    service.resetRateIscrizione(fd)
                    .then((res) => {
                        let severity = res.item.esito
                        let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                        let detail = res.item.messaggio
                        
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                        if (res.item.esito === 'success') {
                            initData()
                            getCorsi()
                            getDaPagare()
                        }
                    }).finally(() => {
                        loading.value = false
                    })
                }
            });
        }

        const onSelectRata = (evt, i) => {
            Object.keys(mensilita_da_completare.value).forEach(mensilita => {
                mensilita_da_completare.value[mensilita].selected = Number(mensilita) == i
            })
            importorata.value=mensilita_da_completare.value[i].importo
            iscrizione_da_aggiornare.value.rata = []
            iscrizione_da_aggiornare.value.iscrizione.id=id
            iscrizione_da_aggiornare.value.rata.push(mensilita_da_completare.value[i])
        }
    
        const canUpdateIscrizione = computed(()=>{
            return iscrizione_da_aggiornare.value.rata.length
        })

        const updateRateIscrizione = async () => {
            loading.value = true
            let fd = new FormData();
            
            fd.append('iscrizione', JSON.stringify(iscrizione_da_aggiornare.value));
            fd.append('inizioCorso', inizioCorso.value ? moment(inizioCorso.value).format('YYYY-MM-DD') : '');
            fd.append('importo',importorata.value);
            
            service.updateRateIscrizione(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                initData()
            }).finally(() => {
                loading.value = false
            })
        }
        const initData = () => {
            mensilita_da_completare.value = null
            iscrizione_da_aggiornare.value = {
                iscrizione: null,
                id_atleta:id,
                rata:[]
            }
            expirationDate.value=moment(new Date()).format('01/MM/YYYY')
            expirationDate.value=null
            expirationDateProduct.value=moment(new Date()).format('01/MM/YYYY')
            expirationDateProduct.value=null
            showDialogCompletaIscrizione.value = false
            const promises = [getCitta(),getPaga(),getDocs(),getDaPagare(), getTypePay(), getAthleteTournamentsData()]
            getPromises(promises)
        }

        onMounted(() => { 
            initData()
        })

        const getDocUrl = (imgPath) => {
            window.open( `${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${imgPath}`);
        }
            
        return {
            moment,
            showNote,
            getDocUrl,
            loading,
            loaded_data,
            utente,
            atleta,
            update,
            genders,
            dapagare,
            isDialogVisible,
            confirmRemoveCorso,
            isDialogVisibleToPay,
            isDialogVisibleAppPresentation,
            confirmSendAppPresentation,
            sendAppPresentation,
            numeroRataSelezionata,
            onCellEditComplete,
            removeToPay,
            confirmRemoveToPay,
            sendRicevuta,
            cancellaRicevuta,
            users,
            citta,
            corsi,
            notifiche,
            emails,
            docs,
            showAddCorso,
            openMotiviDialog,
            showMotiviDialog,
            selectedCorsoMotivi,
            checkedMotivi,
            totalToPay,
            totalPaid,
            handleSubmitProducts,
            sendNewDataAtleta,
            submitted,
            changeUpdate,
            changeUpdateUtente,
            updateUtente,
            validationErrors,
            getDetailsAccordion,
            setPagamentoDialog,
            setPagamento,

tuttiIPagamenti,rowHasField,
            pagamento,
            metaKey,
            viewSetPagamento,
            viewTaglie,
            types_pay,
            selectPayment,
            selectSize,
            type_size,
            sendPagamento,
            onRowSelect,
            canSavePagamento,
            pagamenti,
            vendite,
            noteProduct,
            importoProduct,
            id_pagamento,
            viewRicevuta,
            goToCorso,
            showIscrizione,
            showUtente,
            onUtenteChange,
            showDialogCaricaFile,
            showDialogCompletaIscrizione,
            file,
            type,
            importorata,
            aggiornaRicevuta,
            expirationDate,
            expirationDateProduct,
            handleFileChange,
            showexpirationDateProduct,
            handleSubmit,
            typeofFiles,
            inizioCorso,
            coursesMonthlyData,
            coursesMonthlyDataOLD,
  selectedMonth,
  selectMonth,
  selectedWeek,
  selectWeek,
  isWeeklyCourse,
  weeks,
  months,
  confermaCancellazione,
            openDialogFiles,
            removeDoc,
            isDialogVisibleDoc,
            confirmRemoveDoc,
            removeCorso,
            setRate,
            resetPagamenti,
            mensilita_da_completare,
            onSelectRata,
            canUpdateIscrizione,
            updateRateIscrizione,
            iscrizione_da_aggiornare,
            showDialogProdotti,
            changeProdottoToBuy,
            openDialogProdotti,
            salvaModifiche,
            openDialogModificaImporto,
            dialogModificaVisible,
            modificaData,
            gotoVendita,
            onCheckboxChange,
            products,
            prodottoToBuy,
            kitToBuy,
            kits,
            handleSubmitKit,
            showDialogKit,
            corsiToAdd,popupVisible,corsoSelezionato,mensilitaSelezionata,confermaSelezione,openPopup,periodoSelezionato,
            openDialogKit,handleSubmitAddCorso,addCorso,selectedCorso,
            giorni,limitSelection,selectedDays,weekDays,
             showNotificationDialog,
      notification,
      openSendNotificationDialog,
      closeSendNotificationDialog,
      sendNotification,
      scadenzaDialogVisible,
      openDialogScadenza,
    closeScadenzaDialog,
 nuovadatascadenza ,
 selecteddapagare ,saveScadenza,getScadenzaClass,prenotazioni,figc,
 scadenzaFieldType,
 siblingAthletes,
 siblingAthletesDialogVisible,
 showSiblingAthletesDialog,
 openAthleteDetail,
 showDailyDetails,
 showDailyDetailsDialog,
 dailyPresenceData,
 aggregatePresenceData,
 athleteTournaments,
 selectedIscrizioneAcconto,
 selectedTorneoAcconto,
 selectedProdottoAcconto,
 selectedKitAcconto,
 athleteCourses,
 athleteProducts,
 athleteKits,
 showSplitDialog,
 splitData,
 openSplitDialog,
 confirmSplit,
 splitTotalMismatch,
  openDialogTorneo,
  saveTorneo,
  dialogTorneoVisible,
  selectedTorneoId,
  showDialogModificaDoc,
  edit_type,
  edit_expirationDate,
  openEditDocDialog,
  handleUpdateDoc,
}
    },
}
</script>

<style>
.img-atleta{
    aspect-ratio: 4/2.5 !important;
}
.field {
  margin-bottom: 1em;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.text-danger {
    color: red;
    font-weight: bold;
}
.text-warning {
    color: orange;
    font-weight: bold;
}
.month-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  max-width: 100%;
}

.month-btn {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s;
}

.month-btn:hover {
  background-color: #e9ecef;
}

.month-btn.selected {
  background-color: #0288D1;
  color: white;
  border-color: #0288D1;
}

.max-h-15rem {
  max-height: 15rem;
}
.overflow-y-auto {
  overflow-y: auto;
}
</style>
